<template>
    <div class="home-container">
        <section class="d-flex flex-column gap-3 align-items-start">
            <div class="election-common-statistics-grid-wrapper w-100">
                <div class="election-main-statistics-wrapper d-flex flex-column gap-4">
                    <form class="d-flex gap-2 text-start flex-wrap align-items-center" @submit.prevent="submitMianStatisticsFilters">
                        <h5 class="large-text font-weight-600 extra-black-color me-3 me-xxl-5">სტატისტიკა</h5>
                        <Multiselect v-model="mainStatisticsFiltersInfoObj.cityID" :options="this.mainStatisticsMultiselectsArray[1].options" :mode="this.mainStatisticsMultiselectsArray[1].mode"
                                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" id="city"
                                :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, mainStatisticsMultiselectsArray, mainStatisticsFiltersInfoObj)" @deselect="() => blockNextMultiselects(2, mainStatisticsMultiselectsArray, mainStatisticsFiltersInfoObj)" @clear="() => blockNextMultiselects(2, mainStatisticsMultiselectsArray, mainStatisticsFiltersInfoObj)"
                                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.mainStatisticsMultiselectsArray[1].placeholder" :disabled="this.mainStatisticsMultiselectsArray[1].isDisabled" insert/>
                        <Multiselect v-model="mainStatisticsFiltersInfoObj.regionID" :options="this.mainStatisticsMultiselectsArray[2].options" :mode="this.mainStatisticsMultiselectsArray[2].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 3, true, true, mainStatisticsMultiselectsArray, mainStatisticsFiltersInfoObj)" @deselect="() => blockNextMultiselects(3, mainStatisticsMultiselectsArray, mainStatisticsFiltersInfoObj)" @clear="() => blockNextMultiselects(3, mainStatisticsMultiselectsArray, mainStatisticsFiltersInfoObj)"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.mainStatisticsMultiselectsArray[2].placeholder" :disabled="this.mainStatisticsMultiselectsArray[2].isDisabled" insert/>
                        <Multiselect v-model="mainStatisticsFiltersInfoObj.districtID" :options="this.mainStatisticsMultiselectsArray[3].options" :mode="this.mainStatisticsMultiselectsArray[3].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.mainStatisticsMultiselectsArray[3].placeholder" :disabled="this.mainStatisticsMultiselectsArray[3].isDisabled" insert/>
                        <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                    </form>
                    <div class="d-flex flex-column align-items-center gap-3 w-100 text-start extra-black-color">
                        <div class="map-side-bar-common-block green-border text-start">
                            <div class="common-right-border green-border d-flex flex-column align-items-start justify-content-center gap-1 p-2">
                                <p class="text-start light-text font-weight-600">ამომრჩევლის აქტივობა</p>
                                <p v-if="!this.mainStatisticsInformation?.district" class="text-start extra-light-text light-gray-color">{{ `უბანი: ${this.mainStatisticsInformation?.elect_district_count}/${this.mainStatisticsInformation?.district_count}` }}</p>
                            </div>
                            <div class="common-right-border green-border d-flex align-items-center justify-content-center align-items-center gap-1 p-2">
                                <p class="text-start large-text extra-black-color font-weight-600">{{ `${this.mainStatisticsInformation?.elect_count}` }}</p>
                            </div>
                            <div class="common-right-border d-flex align-items-center justify-content-center gap-1 p-2">
                                <p class="text-start extra-large-text extra-black-color font-weight-600">{{ `${this.mainStatisticsInformation?.sum_count?(this.mainStatisticsInformation?.elect_count / this.mainStatisticsInformation?.sum_count * 100).toFixed(2):0}%`}}</p>
                            </div>
                        </div>
                        <div class="map-side-bar-common-block blue-border text-start">
                            <div class="common-right-border blue-border d-flex flex-column justify-content-center align-items-start gap-1 p-2">
                                <p class="text-start light-text font-weight-600">მხარდამჭერების აქტივობა</p>
                                <p v-if="!this.mainStatisticsInformation?.district" class="text-start extra-light-text light-gray-color">{{ `უბანი: ${this.mainStatisticsInformation?.elect_district_count}/${this.mainStatisticsInformation?.district_count}` }}</p>
                            </div>
                            <div class="common-right-border blue-border d-flex align-items-center justify-content-center align-items-center gap-1 p-2">
                                <p class="text-start large-text extra-black-color font-weight-600">{{ `${this.mainStatisticsInformation?.supporter_count}` }}</p>
                            </div>
                            <div class="common-right-border d-flex align-items-center justify-content-center gap-1 p-2">
                                <p v-if="this.mainStatisticsInformation.hasOwnProperty('country_supporter_count')" class="text-start extra-large-text extra-black-color font-weight-600">{{  `${this.mainStatisticsInformation?.country_supporter_count?(Number(this.mainStatisticsInformation?.supporter_count) / this.mainStatisticsInformation?.country_supporter_count * 100).toFixed(2):0}%` }}</p>
                                <p v-if="this.mainStatisticsInformation.hasOwnProperty('city_supporter_count')" class="text-start extra-large-text extra-black-color font-weight-600">{{  `${this.mainStatisticsInformation?.city_supporter_count?(Number(this.mainStatisticsInformation?.supporter_count) / this.mainStatisticsInformation?.city_supporter_count * 100).toFixed(2):0}%` }}</p>
                                <p v-if="this.mainStatisticsInformation.hasOwnProperty('region_supporter_count')" class="text-start extra-large-text extra-black-color font-weight-600">{{  `${this.mainStatisticsInformation?.region_supporter_count?(Number(this.mainStatisticsInformation?.supporter_count) / this.mainStatisticsInformation?.region_supporter_count * 100).toFixed(2):0}%` }}</p>
                                <p v-if="this.mainStatisticsInformation.hasOwnProperty('district_supporter_count')" class="text-start extra-large-text extra-black-color font-weight-600">{{  `${this.mainStatisticsInformation?.district_supporter_count?(Number(this.mainStatisticsInformation?.supporter_count) / this.mainStatisticsInformation?.district_supporter_count * 100).toFixed(2):0}%` }}</p>
                            </div>
                        </div>
                        <div class="map-side-bar-common-block orange-border text-start">
                            <div class="common-right-border orange-border d-flex flex-column justify-content-center align-items-start gap-1 p-2">
                                <p class="text-start light-text font-weight-600">დარღვევების რაოდენობა</p>
                            </div>
                            <div class="common-right-border orange-border d-flex align-items-center justify-content-center align-items-center gap-1 p-2">
                                <p class="text-start large-text extra-black-color font-weight-600">{{ `${this.mainStatisticsInformation?.problem_count}` }}</p>
                            </div>
                            <div class="common-right-border d-flex flex-column align-items-center justify-content-center gap-1 p-2">
                                <p class="light-text font-weight-600">უბანი</p>
                                <p v-if="!this.mainStatisticsInformation?.district" class="text-start extra-light-text light-gray-color">{{ `${this.mainStatisticsInformation?.elect_district_count}/${this.mainStatisticsInformation?.district_count}` }}</p>
                                <p v-if="this.mainStatisticsInformation?.district" class="text-start extra-light-text light-gray-color">{{ `${this.mainStatisticsInformation?.district}` }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-start text-start gap-3">
                        <h6 class="light-text extra-gray-color font-weight-600">აქტივობა საათების მიხედვით</h6>
                        <ul v-if="mainStatisticsInformation?.timeAllocation" class="data-according-to-time w-100">
                            <template v-for="(timeAllocation, i) of Object.keys(mainStatisticsInformation.timeAllocation).slice(1)">
                                <li v-if="timeAllocation.startsWith('count')" class="d-flex align-items-center gap-2 gap-xxl-4">
                                    <h6 class="large-text extra-gray-color">{{ this.timeAllocationObj[timeAllocation] }}</h6>
                                    <div class="d-flex align-items-center gap-1">
                                        <span class="light-text font-weight-600 extra-black-color">{{ mainStatisticsInformation.timeAllocation[timeAllocation] }}</span>
                                        <span v-if="maxActivityForElectionStatistic != 0 && mainStatisticsInformation.timeAllocation[timeAllocation] != 0" class="light-text font-weight-600 extra-green-color">{{ maxActivityForElectionStatistic?`${(mainStatisticsInformation.timeAllocation[timeAllocation] / maxActivityForElectionStatistic * 100).toFixed(2)}%`: "0%" }}</span>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <div class="detailed-statistics d-flex flex-column align-items-stretch justify-content-start">
                    <div class="d-flex justify-content-between align-items-center">
                        <h4 class="text-start large-text extra-black-color font-weight-600">დეტალურად</h4>
                        <div ref="detailedElectionInfoAll" class="d-flex align-items-center gap-2">
                            <primaryButtonComponent v-for="(data, i) of detailedElectionInfoAllgetterButtonsArray" :mode="data.mode" @click="detailedElectionInfoAllGetterButtonsHandler(i)" buttonType="button" paddingX="14px" paddingY="8px" class="before-large-text font-weight-600" buttonWidth="max-content">
                                <template v-slot:content>
                                    <p>{{ data.content }}</p>
                                </template>
                            </primaryButtonComponent>
                        </div>
                    </div>
                    <div class="common-table-container rounded-0 common-scrollbar mt-2 d-flex flex-column justify-content-between h-100">
                        <table class="common-tablee">
                            <thead>
                                <tr>
                                    <th class="light-text light-blue-color">
                                        დასახელება
                                    </th>
                                    <th v-for="(item, i) of detailedMainStatisticsOrderByButtonsArray" @click="handleDetailedStatisticsAscDesc(i)" class="light-text light-blue-color">
                                        <ascDescBlock :isActive="item.isActive" :activeMode="item.activeMode">
                                            <template v-slot:text-content>
                                                {{ item.content }}
                                            </template>
                                        </ascDescBlock>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, i) of detailedElectionInformation" @click="activateModalMode(data.district?'seeDetailedStatisticsByDistrict':'seeDetailedStatisticsByRegion', true), data.district?getDetailedStatisticsByDistrict(data.district, data.districtID):getDetailedStatisticsByRegion(data.region, data.regionID)" class="light-black-color light-text cursor-pointer">
                                    <td v-if="data.district"><p>{{ data.district }}</p></td>
                                    <td v-else><p>{{ data.region }}</p></td>
                                    <td>
                                        <div class="d-flex justify-content-center w-100">
                                            <p style="width: 70%; text-align: center">
                                                <span class="font-weight-600">{{ `${data.elect_count}/` }}</span>
                                                {{ `${data.sum_count}` }}
                                            </p>
                                            <p style="width: 30%; text-align: start" class="extra-green-color">{{ `${data.sum_count?(Number(data.elect_count)/Number(data.sum_count)*100).toFixed(2): 0}%` }}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <p style="text-align: center; width: 70%;" class="d-flex justify-content-center w-100">
                                                <span class="font-weight-600">{{ `${data.supporter_count}/` }}</span>
                                                <span v-if="data.hasOwnProperty('region_supporter_count')">{{ `${data.region_supporter_count}` }}</span>
                                                <span v-if="data.hasOwnProperty('district_supporter_count')">{{ `${data.district_supporter_count}` }}</span>
                                            </p>
                                            <p style="width: 30%; text-align: start" v-if="data.hasOwnProperty('region_supporter_count')" class="extra-green-color">{{ `${data.region_supporter_count?(Number(data.supporter_count)/Number(data.region_supporter_count)*100).toFixed(2): 0}%` }}</p>
                                            <p style="width: 30%; text-align: start" v-if="data.hasOwnProperty('district_supporter_count')" class="extra-green-color">{{ `${data.district_supporter_count?(Number(data.supporter_count)/Number(data.district_supporter_count)*100).toFixed(2): 0}%` }}</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="d-flex align-items-center justify-content-between">
                            <vue-awesome-paginate
                                :total-items="mainStatisticsPagingInfo.total"
                                :items-per-page="mainStatisticsPagingInfo.limit"
                                :max-pages-shown="2"
                                v-model="mainStatisticsPagingInfo.offset"
                                :hide-prev-next-when-ends="true"
                                :hide-prev-next="true"
                                :show-breakpoint-buttons="true"
                                :disable-breakpoint-buttons="false"
                                @click="mainStatisticsPaginationClickHandler"
                                class="my-2 align-self-center"
                            />
                            <excelFileDownloadComponent :disabled="isSending" @igniteDownload="igniteDetailedStatisticsDownload" @abortDownload="abortDetailedStatisticsDownload" excelFileName="election-sorted-problems" :namesArray="['უბნები', 'ოლქები']" :jsonToExcelArray="mainStatisticsjsonToExcelArray" :downloadInAction="mainStatisticsdownloadInAction" :canAbortDownload="true"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="pageMode == 0" class="main-info-section d-flex flex-column align-items-start gap-3">
            <div class="election-cards-and-table-wrapper w-100">
                <div class="election-left-side d-flex flex-column align-items-stretch gap-3 p-3 border-radius-20">
                    <div class="d-flex align-items-center justify-content-between gap-3">
                        <div class="d-flex align-items-center gap-3">
                            <h3 class="extra-large-text">დარღვევები</h3>
                            <h3 class="extra-large-text extra-red-color">{{ pagingInfo.total }}</h3>
                        </div>
                        <primaryButtonComponent @click="changePageMode(1)" buttonType="button" paddingX="14px" paddingY="8px" class="large-text font-weight-600" buttonWidth="max-content">
                            <template v-slot:content>
                                <p>რუქაზე ნახვა</p>
                            </template>
                        </primaryButtonComponent>
                    </div>
                    <form class="search-container-form" @submit.prevent="submitFilters">
                        <fieldset class="filters-wrapper">
                            <Multiselect ref="districtID" v-model="filtersInfoObj.cityID" :options="this.localeMultiselectArray[1].options" :mode="this.localeMultiselectArray[1].mode"
                                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1" id="city"
                                :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, localeMultiselectArray, filtersInfoObj)" @deselect="() => blockNextMultiselects(2, localeMultiselectArray, filtersInfoObj)" @clear="() => blockNextMultiselects(2, localeMultiselectArray, filtersInfoObj)"
                                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.localeMultiselectArray[1].placeholder" :disabled="this.localeMultiselectArray[1].isDisabled" insert/>
                            <Multiselect ref="districtID" v-model="filtersInfoObj.regionID" :options="this.localeMultiselectArray[2].options" :mode="this.localeMultiselectArray[2].mode"
                                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                                :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 3, true, true, localeMultiselectArray, filtersInfoObj)" @deselect="() => blockNextMultiselects(3, localeMultiselectArray, filtersInfoObj)" @clear="() => blockNextMultiselects(3, localeMultiselectArray, filtersInfoObj)"
                                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.localeMultiselectArray[2].placeholder" :disabled="this.localeMultiselectArray[2].isDisabled" insert/>
                            <Multiselect ref="districtID" v-model="filtersInfoObj.districtID" :options="this.localeMultiselectArray[3].options" :mode="this.localeMultiselectArray[3].mode"
                                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                                :hideSelected="true" locale="ge"
                                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.localeMultiselectArray[3].placeholder" :disabled="this.localeMultiselectArray[3].isDisabled" insert/>

                            <Multiselect v-for="(data, i) of problemTypesMultiselectArray" v-model="filtersInfoObj.problemTypeID" name="goingTypeID" id="goingTypeID" :options="data.options" :mode="data.mode"
                                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                                :hideSelected="true" locale="ge" :canDeselect="true" :canClear="true"
                                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                            <Multiselect v-model="filtersInfoObj.checkBoxesArray" :options="this.checkBoxesMultiselectArray[0].options" :mode="this.checkBoxesMultiselectArray[0].mode"
                                :searchable="true" :loading="false" :close-on-select="true" :object="true" :resolve-on-load="false" :min-chars="1"
                                :hideSelected="true" locale="ge" id="checkbox"
                                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.checkBoxesMultiselectArray[0].placeholder" :disabled="this.checkBoxesMultiselectArray[0].isDisabled" insert/>
                            <button @click="resetFilters" type="button" class="extra-light-text extra-red-color ms-2" style="font-weight: 600; background-color: transparent;">გასუფთავება</button>
                            <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                        </fieldset>
                    </form>
                    <div class="d-flex flex-column justify-content-between gap-2" style="height: 100%">
                        <div class="cards-common-grid-wrapper">
                            <template v-for="(problem, i) of electionProblemsInfo">
                                <commonCardAccordion v-if="!isAccordionOpened || indexOfOpenedAccordion == i" backgroundColor="#F5F7FA" :allowStaticClose="true" @openAccordionOnIndex="openAccordionOnIndex(i, problem.election_problemID, problem.seen)" @closeAccordionOnIndex="closeAccordionOnIndex(i)" :closeTrigger="accordionCardCloseTrigger">
                                    <template v-slot:left>
                                        <div class="d-flex flex-column align-items-start">
                                            <p class="light-text font-weight-600 light-black-color">{{ problem.problem_type.election_problem_type }}</p>
                                            <p class="extra-light-text light-blue-color">{{ problem.election_date }}</p>
                                        </div>
                                    </template>
                                    <template v-slot:middle>
                                        <ul class="d-flex align-items-center gap-4">
                                            <li class="d-flex flex-column align-items-center gap-1">
                                                <p class="extra-light-text extra-gray-color">ოლქი</p>
                                                <p class="light-text font-weight-600 light-black-color">{{ `${problem.district.region.region}` }}</p>
                                            </li>
                                            <li class="d-flex flex-column align-items-center gap-1">
                                                <p class="extra-light-text extra-gray-color">უბანი</p>
                                                <p class="light-text font-weight-600 light-black-color">{{ `${problem.district.district}` }}</p>
                                            </li>
                                            <li class="d-flex flex-column align-items-center gap-1">
                                                <p class="extra-light-text extra-gray-color">კომენტარი</p>
                                                <p class="light-text font-weight-600 light-black-color">{{ `${problem?.comment?.length > 0? "კი": "არა"}` }}</p>
                                            </li>
                                            <li class="d-flex flex-column align-items-center gap-1">
                                                <p class="extra-light-text extra-gray-color">ფოტო/ვიდეო</p>
                                                <p class="light-text font-weight-600 light-black-color">{{ `${problem?.problem_files?.length > 0? "კი": "არა"}` }}</p>
                                            </li>
                                            <img v-if="problem.seen == 1" src="@\assets\images\seen.svg" alt="seen" style="width: 18px; height: 18px;">
                                            <div v-else style="width: 22px"></div>
                                        </ul>
                                    </template>
                                    <template v-slot:additionalInfo>
                                        <div class="d-flex flex-column gap-3 align-items-start">
                                            <article class="d-flex flex-column gap-3 align-items-start w-100">
                                                <h4 class="light-text font-weight-600 light-black-color">პრობლემების სია</h4>
                                                <ul class="problem-images-wrapper d-flex align-items-start justify-content-start flex-wrap gap-2">
                                                    <li class="blue-part-input">
                                                        {{ problem.problem_type.election_problem_type }}
                                                    </li>
                                                </ul>
                                            </article>
                                            <article class="d-flex flex-column gap-2 align-items-start w-100">
                                                <h4 class="light-text font-weight-600 light-black-color">დამატებითი ტექსტი</h4>
                                                <textarea readonly :id="'additional-text'+i" :name="'additional-text'+i" cols="100" rows="10" placeholder="დამატებითი ტექსტი" class="blue-part-input extra-light-text">{{ problem.comment }}</textarea>
                                            </article>
                                            <article class="d-flex flex-column gap-3 align-items-start w-100">
                                                <h4 class="light-text font-weight-600 light-black-color">ვიზუალური მასალა</h4>
                                                <ul class="problem-images-wrapper d-flex align-items-start justify-content-start flex-wrap gap-2">
                                                    <template v-if="problem.problem_files.length > 4" v-for="(fileObj, i) of problem.problem_files">
                                                        <li v-if="fileObj.file_type == 1">
                                                            <img @click="activateModalMode('photo', true), setElectionPhoto(`data:image/jpeg;base64,${fileObj.election_file}`, problem.district.district)" :src="`data:image/jpeg;base64,${fileObj.election_file}`" alt="image" class="cursor-pointer" loading="lazy">
                                                        </li>
                                                        <li v-if="fileObj.file_type == 2">
                                                            <button :disabled="isSending" @click="activateModalMode('video', true), getElectionProblemVideo({election_problemID: fileObj.election_problemID, file_name: fileObj.election_file})" buttonType="submit" class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: var(--extra-green); color: var(--secondary-background-color); cursor: pointer">ვიდეო მასალა</button>
                                                        </li>
                                                        <li v-if="fileObj.file_type == 3">
                                                            <button :disabled="isSending" @click="activateModalMode('audio', true), getElectionProblemAudio({election_problemID: fileObj.election_problemID, file_name: fileObj.election_file})" buttonType="submit" class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: var(--extra-green); color: var(--secondary-background-color); cursor: pointer">აუდიო მასალა</button>
                                                        </li>
                                                    </template>
                                                    <template v-else v-for="(fileObj, i) of [0, 1, 2, 3, 4]">
                                                        <li v-if="problem?.problem_files[i]?.file_type == 1">
                                                            <img @click="activateModalMode('photo', true), setElectionPhoto(`data:image/jpeg;base64,${problem.problem_files[i].election_file}`, problem.district.district)" :src="`data:image/jpeg;base64,${problem.problem_files[i].election_file}`" alt="image" class="cursor-pointer" loading="lazy">
                                                        </li>
                                                        <li v-else-if="problem?.problem_files[i]?.file_type == 2">
                                                            <button :disabled="isSending" @click="activateModalMode('video', true), getElectionProblemVideo({election_problemID: problem.problem_files[i].election_problemID, file_name: problem.problem_files[i].election_file})" buttonType="submit" class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: var(--extra-green); color: var(--secondary-background-color); cursor: pointer">ვიდეო მასალა</button>
                                                        </li>
                                                        <li v-else-if="problem?.problem_files[i]?.file_type == 3">
                                                            <button :disabled="isSending" @click="activateModalMode('audio', true), getElectionProblemAudio({election_problemID: problem.problem_files[i].election_problemID, file_name: problem.problem_files[i].election_file})" buttonType="submit" class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: var(--extra-green); color: var(--secondary-background-color); cursor: pointer">აუდიო მასალა</button>
                                                        </li>
                                                        <li v-else>
                                                            <div class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: gray; color: var(--secondary-background-color)">empty</div>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </article>
                                            <article class="d-flex align-items-center justify-content-between w-100 flex-wrap gap-3">
                                                <ul class="d-flex flex-row align-items-center justify-content-start extra-light-text light-blue-color flex-wrap gap-3 gap-xl-4 mt-3">
                                                    <li>
                                                        <h6 class="light-black-color text-start light-text font-weight-600">ავტორი</h6>
                                                        <p class="text-start">{{ `${problem?.user?.name} ${problem?.user?.surename}` }}</p>
                                                    </li>
                                                    <li>
                                                        <h6 class="light-black-color text-start light-text font-weight-600">ტელეფონი</h6>
                                                        <p class="text-start">{{ `${problem?.user?.phone}` }}</p>
                                                    </li>
                                                    <li>
                                                        <h6 class="light-black-color text-start light-text font-weight-600">უბნის მისამართი</h6>
                                                        <p class="text-start">{{ `${problem?.district.address}` }}</p>
                                                    </li>
                                                </ul>
                                                <button>
                                                    <img src="@/assets/images/printIcon.svg" alt="download">
                                                </button>
                                            </article>
                                        </div>
                                    </template>
                                </commonCardAccordion>
                            </template>
                        </div>
                        <div class="d-flex justify-content-between align-items-center w-100">
                            <vue-awesome-paginate
                                :total-items="pagingInfo.total"
                                :items-per-page="pagingInfo.limit"
                                :max-pages-shown="4"
                                v-model="pagingInfo.offset"
                                :hide-prev-next-when-ends="true"
                                :hide-prev-next="true"
                                :show-breakpoint-buttons="true"
                                @click="paginationClickHandler"
                                class="my-2 align-self-center"
                            />
                            <excelFileDownloadComponent :disabled="isSending" @igniteDownload="igniteDownload" @abortDownload="electionProblemsAbortDownload" excelFileName="election-problems" :namesArray="['election problems']" :jsonToExcelArray="jsonToExcelArray" :downloadInAction="downloadInAction" :canAbortDownload="true"/>
                        </div>
                    </div>
                </div>
                <div class="table-wrapper common-scrollbar border-radius-20 d-flex flex-column justify-content-between p-3">
                    <div class="d-flex flex-column align-items-stretch">
                        <div class="d-flex gap-3">
                            <primaryButtonComponent :mode="problemTypesButtonVmodel.mode" @click="handleProblemTypesRouteSet(0)" buttonType="button" paddingX="14px" paddingY="8px" class="large-text font-weight-600" buttonWidth="max-content">
                                <template v-slot:content>
                                    <p>დარღვევები</p>
                                </template>
                            </primaryButtonComponent>
                            <Multiselect ref="cityID" v-model="this.problemTypesFiltersMultiselectArray[0].Vmodel" :options="this.problemTypesFiltersMultiselectArray[0].options" :mode="this.problemTypesFiltersMultiselectArray[0].mode"
                                :searchable="true" :loading="false" :close-on-select="true" :object="true" :resolve-on-load="false" :min-chars="1"
                                :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" id="city"
                                @select="(value, option) => handleProblemTypesRouteSet(1)"
                                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.problemTypesFiltersMultiselectArray[0].placeholder" :disabled="this.problemTypesFiltersMultiselectArray[0].isDisabled" insert/>
                        </div>
                        <div class="d-flex flex-column align-items-end gap-3">
                            <div class="common-table-container common-scrollbar common-vertical-overflow mt-2" style="height: 100%">
                                <table class="common-tablee">
                                    <thead>
                                        <tr>
                                            <th class="light-text light-blue-color">
                                                დასახელება
                                            </th>
                                            <th>
                                                <ascDescBlock @click="problemTypesOrderByButonHandler" :isActive="problemTypesOrderByButtonsObj.isActive" :activeMode="problemTypesOrderByButtonsObj.activeMode">
                                                    <template v-slot:text-content>
                                                        {{ problemTypesOrderByButtonsObj.content }}
                                                    </template>
                                                </ascDescBlock>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="common-scrollbar common-vertical-overflow">
                                        <template v-if="problemTypesInformation[0]?.district != null" v-for="(problem, i) of problemTypesInformation">
                                            <tr class="light-black-color light-text cursor-pointer" @click="activateModalMode('seeProblemTypesReportByDistrict', true), getElectionProblemTypesByDistrict(problem.districtID, problem.district)">
                                                <td><p>{{problem.district}}</p></td>
                                                <td class="font-weight-600"><p>{{problem.election_problem_count}}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="problemTypesInformation[0]?.region != null" v-for="(problem, i) of problemTypesInformation">
                                            <tr class="light-black-color light-text cursor-pointer" @click="activateModalMode('seeProblemTypesReportByRegion', true), getElectionProblemTypesByRegion(problem.regionID, problem.region)">
                                                <td><p>{{problem.region}}</p></td>
                                                <td class="font-weight-600"><p>{{problem.election_problem_count}}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="problemTypesInformation[0]?.election_problem_type != null" v-for="(problem, i) of problemTypesInformation">
                                            <tr class="light-black-color light-text cursor-pointer" @click="activateModalMode('seeProblemTypesReportByCountry', true), getRegionsByCountryProblemType(problem.election_problem_typeID, problem.election_problem_type)">
                                                <td><p>{{problem.election_problem_type}}</p></td>
                                                <td class="font-weight-600"><p>{{problem.election_problem_count}}</p></td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-items-center w-100 justify-content-between flex-wrap">
                        <vue-awesome-paginate
                            :total-items="problemTypesPagingInfo.total"
                            :items-per-page="problemTypesPagingInfo.limit"
                            :max-pages-shown="3"
                            v-model="problemTypesPagingInfo.offset"
                            :hide-prev-next-when-ends="true"
                            :hide-prev-next="true"
                            :show-breakpoint-buttons="true"
                            @click="problemTypesPaginationClickHandler"
                            class="my-2 align-self-center"
                        />
                        <excelFileDownloadComponent :disabled="isSending" @igniteDownload="problemTypesIgniteDownload" @abortDownload="problemTypesAbortDownload" excelFileName="election-problems" :namesArray="['პრობლემები საქართველოში', 'პრობლემები ოლქებში', 'პრობლემები უბნებში']" :jsonToExcelArray="problemTypesjsonToExcelArray" :downloadInAction="problemTypesdownloadInAction" :canAbortDownload="true"/>
                    </div>
                </div>
            </div>
        </section>
        <section v-else class="map-section-wrapper w-100">
            <div class="map-wrapper common-box-shadow">
                
                <primaryButtonComponent v-if="mapMode != 0" @click="mapGoBackHandler" buttonType="button" paddingX="14px" paddingY="8px" class="go-back-button large-text font-weight-600" buttonWidth="max-content">
                    <template v-slot:content>
                        <p>უკან გამოსვლა</p>
                    </template>
                </primaryButtonComponent>
                <div class="map-hover-info-button font-weight-600 d-flex extra-black-color extra-black-color large-text common-box-shadow">
                    <p v-if="currentlyHoveredRegion.id"> {{ `#${this.currentlyHoveredRegion.id == -1 || this.currentlyHoveredRegion.id == null ?"":this.currentlyHoveredRegion.id} ${this.currentlyHoveredRegion.name}` }}</p>
                    <p v-else-if="currentlySelectedTbilisiRegion.id"> {{ `#${this.currentlySelectedTbilisiRegion.id?this.currentlySelectedTbilisiRegion.id:""} ${this.currentlySelectedTbilisiRegion.name?this.currentlySelectedTbilisiRegion.name:""}` }}</p>
                    <p v-else> {{ `#${this.currentlySelectedRegion.id == -1 || this.currentlySelectedRegion.id == null?"": this.currentlySelectedRegion.id} ${this.currentlySelectedRegion.name?this.currentlySelectedRegion.name:""}` }}</p>
                </div>
                <georgiaMap v-if="mapMode == 0"/>
                <tbilisiMap v-else-if="mapMode == 1"/>
                <div v-else-if="mapMode == 2">
                    <markerMapComponent height="400px" :markersInfo="markerInfoArray" :zoomOn="zoomedMarkerIndex" :zoomLevel="11" @getMarkerInfo="getDistrictDetails"/>
                </div>
            </div>
            <div class="map-side-bar common-box-shadow d-flex flex-column align-items-center">
                <div class="p-3 map-side-bar-header w-100 d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center gap-2">
                        <img src="@/assets/images/location.svg" style="width: 30px" alt="location">
                        <h4 v-if="currentlySelectedRegionDetails.pathID" class="text-start large-text middle-green-color font-weight-600">{{ `#${currentlySelectedRegionDetails.pathID} ${currentlySelectedRegionDetails.region}` }}</h4>
                        <h4 v-if="currentlySelectedRegionDetails.country_supporter_count" class="text-start large-text middle-green-color font-weight-600">საქართველო</h4>
                        <h4 v-if="isTbilisiSelected == true" class="text-start large-text middle-green-color font-weight-600">თბილისი</h4>
                        <div v-if="currentlySelectedRegionDetails.district" class="d-flex align-items-center gap-1">
                            <primaryButtonComponent @click="fillMarkerInfoArray(this.currentlySelectedTbilisiRegion.id?this.currentlySelectedTbilisiRegion.id:this.currentlySelectedRegion.id)" buttonType="button" paddingX="14px" paddingY="8px" class="large-text font-weight-600" buttonWidth="max-content">
                                <template v-slot:content>
                                    <p>{{ currentlySelectedRegionDetails.region }}</p>
                                </template>
                            </primaryButtonComponent>
                            <h4 class="text-start large-text middle-green-color font-weight-600">{{ `#${currentlySelectedRegionDetails.district}` }}</h4>
                        </div>
                    </div>
                    <primaryButtonComponent @click="changePageMode(0)" buttonType="button" paddingX="14px" paddingY="8px" class="large-text font-weight-600" buttonWidth="max-content">
                        <template v-slot:content>
                            <p>ცხრილში ნახვა</p>
                        </template>
                    </primaryButtonComponent>
                </div>
                <div class="p-3 d-flex flex-column align-items-center gap-3 w-100 text-start extra-black-color">
                    <div class="map-side-bar-common-block green-border text-start">
                        <div class="common-right-border green-border d-flex flex-column align-items-start gap-1 p-2">
                            <p class="text-start light-text font-weight-600">ამომრჩევლის აქტივობა</p>
                            <p v-if="currentlySelectedRegionDetails.district_count" class="text-start extra-light-text light-gray-color">{{ `უბანი: ${currentlySelectedRegionDetails.elect_district_count}/${currentlySelectedRegionDetails.district_count}` }}</p>
                        </div>
                        <div class="common-right-border green-border d-flex align-items-center justify-content-center align-items-center gap-1 p-2">
                            <p class="text-start large-text extra-black-color font-weight-600">{{ `${currentlySelectedRegionDetails.elect_count}` }}</p>
                        </div>
                        <div class="common-right-border d-flex align-items-center justify-content-center gap-1 p-2">
                            <p class="text-start extra-large-text extra-black-color font-weight-600">{{ `${currentlySelectedRegionDetails.sum_count?(currentlySelectedRegionDetails.elect_count / currentlySelectedRegionDetails.sum_count * 100).toFixed(2):0}%`}}</p>
                        </div>
                    </div>
                    <div class="map-side-bar-common-block blue-border text-start">
                        <div class="common-right-border blue-border d-flex flex-column align-items-start gap-1 p-2">
                            <p class="text-start light-text font-weight-600">მხარდამჭერების აქტივობა</p>
                            <p v-if="currentlySelectedRegionDetails.district_count" class="text-start extra-light-text light-gray-color">{{ `უბანი: ${currentlySelectedRegionDetails.elect_district_count}/${currentlySelectedRegionDetails.district_count}` }}</p>
                        </div>
                        <div class="common-right-border blue-border d-flex align-items-center justify-content-center align-items-center gap-1 p-2">
                            <p class="text-start large-text extra-black-color font-weight-600">{{ `${currentlySelectedRegionDetails.supporter_count}` }}</p>
                        </div>
                        <div class="common-right-border d-flex align-items-center justify-content-center gap-1 p-2">
                            <p class="text-start extra-large-text extra-black-color font-weight-600">{{  `${currentlySelectedRegionDetails.region_supporter_count?(currentlySelectedRegionDetails.supporter_count/currentlySelectedRegionDetails.region_supporter_count * 100).toFixed(2):0}%` }}</p>
                        </div>
                    </div>
                    <div class="map-side-bar-common-block orange-border text-start">
                        <div class="common-right-border orange-border d-flex flex-column align-items-start gap-1 p-2">
                            <p class="text-start light-text font-weight-600">დარღვევების რაოდენობა</p>
                        </div>
                        <div class="common-right-border orange-border d-flex align-items-center justify-content-center align-items-center gap-1 p-2">
                            <p class="text-start large-text extra-black-color font-weight-600">{{ `${currentlySelectedRegionDetails.problem_count}` }}</p>
                        </div>
                        <div class="common-right-border d-flex flex-column align-items-start gap-1 p-2">
                            <p class="text-start light-text font-weight-600">უბანი</p>
                            <p v-if="currentlySelectedRegionDetails.district_count" class="text-start extra-light-text light-gray-color">{{ `${currentlySelectedRegionDetails.elect_district_count}/${currentlySelectedRegionDetails.district_count}` }}</p>
                            <p v-if="!currentlySelectedRegionDetails.district_count" class="text-start extra-light-text light-gray-color">{{ `${currentlySelectedRegionDetails.district}` }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    
    <primaryModalComponent :showModal="showModal" maxHeight="781px" maxWidth="846px" @closeModal="triggerModal">
        <template v-slot:modal-content>
            <div class="d-flex flex-column align-items-stretch gap-4">
                <div :class="['d-flex', 'align-items-center', {'justify-content-between': modalMode !== 'audio' && modalMode !== 'video' && modalMode !== 'photo'}, {'justify-content-center': modalMode == 'audio' || modalMode == 'video' || modalMode == 'photo'}]">
                    <h5 class="extra-large-text">
                    {{ `${modalTitle}` }}
                        <span class="extra-green-color">{{ `${modalSubTitle}` }}</span>
                    </h5>
                    <excelFileDownloadComponent v-if="modalMode == 'seeDetailedStatisticsByRegion'" @igniteDownload="detailedPersonalActivityDownloadIgnition" @abortDownload="detailedPersonalActivityAbortDownload" excelFileName="detailed_parsonal_activity" :namesArray="[`აქტივობა ${modalSubTitle}`]" :jsonToExcelArray="detailedPersonalActivityJsonToExcelArray" :downloadInAction="detailedPersonalActivityDownloadInAction" :canAbortDownload="true"/>
                    <excelFileDownloadComponent v-if="modalMode == 'seeDetailedStatisticsByDistrict'" @igniteDownload="detailedPersonalActivityByDistrictDownloadIgnition" @abortDownload="detailedPersonalActivityByDistrictAbortDownload" excelFileName="detailed_parsonal_activity" :namesArray="[`აქტივობა ${modalSubTitle}`]" :jsonToExcelArray="detailedPersonalActivityByDistrictJsonToExcelArray" :downloadInAction="detailedPersonalActivityByDistrictDownloadInAction" :canAbortDownload="true"/>
                </div>
                <div v-if="modalMode == 'audio'" class="d-flex flex-column align-items-center gap-4">
                    <audio id="mainAudio" controls :src="audioURL" class="modal-media">
                                            
                    </audio>
                </div>
                <div v-if="modalMode == 'video'" class="d-flex flex-column align-items-center gap-4">
                    <video id="mainVideo" controls :src="videoURL" style="width: min-content" class="modal-media">
                                            
                    </video>
                </div>
                <div v-if="modalMode == 'photo'" class="d-flex flex-column align-items-center gap-4">
                    <div class="image-wrapper">
                        <button class="download-button" @click="downloadImage(photoURl, `${this.name}.jpg`)">
                            <img src="@/assets/images/download.svg" alt="download">
                        </button>
                        <img class="modal-photo modal-media" :src="photoURl" alt="img"  style="width: auto;">
                    </div>
                </div>
                <div v-if="modalMode.startsWith('seeProblemTypesReport') || modalMode.startsWith('seeDetailedStatistics')" class="modal-reports-wrapper d-flex flex-column gap-2">
                    <div v-if="modalMode.startsWith('seeDetailedStatistics') && regionProblemTypesModalInfo.secondList.length > 0" class="d-flex flex-column align-iems-stretch gap-2 w-100">
                        <div class="d-flex align-items-center gap-1">
                            <h3 class="before-extra-large-text extra-black-color text-start">კაცი</h3>
                            <customProgressLine commonBackgroundColor="#1FD286" :progressLineFillLevel="regionProblemTypesModalInfo.secondList.length > 0 ?`${(menQuantityInDetailedActivity / regionProblemTypesModalInfo.secondList.length * 100).toFixed(0)}%`:'0%'" :showTitle="false" :showRightInfo="true" :showMainSpecifier="false" progressLineHeight="15px">
                                <template v-slot:inner-left-info>
                                    <h3 class="before-extra-large-text extra-black-color extra-green-color">{{ regionProblemTypesModalInfo.secondList.length > 0 ?`${(menQuantityInDetailedActivity / regionProblemTypesModalInfo.secondList.length * 100).toFixed(0)}%`:'0%' }}</h3>
                                </template>
                                <template v-slot:inner-right-info>
                                    <h3 class="large-text">{{ menQuantityInDetailedActivity?menQuantityInDetailedActivity:0 }}</h3>
                                </template>
                            </customProgressLine>
                        </div>
                        <div class="d-flex align-items-center gap-1">
                            <h3 class="before-extra-large-text extra-black-color text-start">ქალი</h3>
                            <customProgressLine commonBackgroundColor="#FFCB10" :progressLineFillLevel="regionProblemTypesModalInfo.secondList.length > 0 ?`${(womenQuantityInDetailedActivity / regionProblemTypesModalInfo.secondList.length * 100).toFixed(0)}%`:'0%'" :showTitle="false" :showRightInfo="true" :showMainSpecifier="false" progressLineHeight="15px">
                                <template v-slot:inner-left-info>
                                    <h3 class="before-extra-large-text extra-black-color extra-orange-color">{{ regionProblemTypesModalInfo.secondList.length > 0 ?`${(womenQuantityInDetailedActivity / regionProblemTypesModalInfo.secondList.length * 100).toFixed(0)}%`:'0%' }}</h3>
                                </template>
                                <template v-slot:inner-right-info>
                                    <h3 class="large-text">{{ womenQuantityInDetailedActivity?womenQuantityInDetailedActivity:0 }}</h3>
                                </template>
                            </customProgressLine>
                        </div>
                    </div>
                    <div class="modal-reports-wrapper d-flex alig-items-center justify-content-between">
                        <div v-if="modalMode == 'seeProblemTypesReportByCountry' || modalMode == 'seeProblemTypesReportByRegion' || modalMode == 'seeDetailedStatisticsByRegion'" class="d-flex flex-column align-items-stretch gap-2 w-100">
                            <h5 v-if="modalMode == 'seeProblemTypesReportByRegion'" class="large-text extra-black-color font-weight-600 text-start">პრობლემების ჩამონათვალი</h5>
                            <h5 v-if="modalMode == 'seeProblemTypesReportByCountry'" class="large-text extra-black-color font-weight-600 text-start">ოლქების ჩამონათვალი</h5>
                            <h5 v-if="modalMode == 'seeDetailedStatisticsByRegion'" class="large-text extra-black-color font-weight-600 text-start">უბნების ჩამონათვალი</h5>
    
                            <div class="common-table-container common-scrollbar common-vertical-overflow" style="border-radius: 0">
                                <table class="common-tablee common-table-container common-scrollbar common-vertical-overflow">
                                    <thead>
                                        <tr>
                                            <th class="light-text light-blue-color">
                                                დასახელება
                                            </th>
                                            <th class="light-text light-blue-color">
                                                რაოდენობა
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody id="modal-left-report-body">
                                        <template v-if="modalMode == 'seeDetailedStatisticsByRegion'" v-for="(district, i) of regionProblemTypesModalInfo.firstList">
                                            <tr @click="getDetailedStatisticsByDistrict(modalSubTitle, district.districtID), manageReportTrColoring($event, i)" class="light-black-color light-text cursor-pointer">
                                                <td><p>{{district.district}}</p></td>
                                                <td class="font-weight-600"><p>{{district.activeUsers}}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="modalMode == 'seeProblemTypesReportByRegion'" v-for="(problem, i) of regionProblemTypesModalInfo.firstList">
                                            <tr @click="getDistrictsByRegionAndProblemType(problem.election_problem_typeID, problem.regionID), manageReportTrColoring($event, i)" class="light-black-color light-text cursor-pointer">
                                                <td><p>{{problem.election_problem_type}}</p></td>
                                                <td class="font-weight-600"><p>{{problem.election_problem_count}}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="modalMode == 'seeProblemTypesReportByCountry'" v-for="(problem, i) of regionProblemTypesModalInfo.firstList">
                                            <tr @click="getElectionProblemDistrictsByRegion(problem.election_problem_typeID, problem.regionID), manageReportTrColoring($event, i)" class="light-black-color light-text cursor-pointer">
                                                <td><p>{{problem.region}}</p></td>
                                                <td class="font-weight-600"><p>{{problem.election_problem_count}}</p></td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="d-flex flex-column align-items-stretch gap-2 w-100">
                            <h5 class="large-text extra-black-color font-weight-600 text-start" v-if="modalMode.startsWith('seeProblemTypesReport')">უბნების ჩამონათვალი</h5>
                            <h5 class="large-text extra-black-color font-weight-600 text-start" v-if="modalMode.startsWith('seeDetailedStatistics')">აქტივობა</h5>
    
                            <div class="common-table-container common-scrollbar common-vertical-overflow">
                                <table class="common-tablee">
                                    <thead>
                                        <tr>
                                            <th class="light-text light-blue-color">
                                                {{ modalMode.startsWith('seeProblemTypesReport')?"დასახელება":"სახელი გვარი"  }}
                                            </th>
                                            <th class="light-text light-blue-color">
                                                {{ modalMode.startsWith('seeProblemTypesReport')?"რაოდენობა":"თარიღი" }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="common-scrollbar common-vertical-overflow">
                                        <template v-if="regionProblemTypesModalInfo.secondList[0]?.election_problem_type != null" v-for="(district, i) of regionProblemTypesModalInfo.secondList">
                                            <tr class="light-black-color light-text">
                                                <td v-if="modalMode == 'seeProblemTypesReportByDistrict'"><p>{{district.election_problem_type}}</p></td>
                                                <td v-else><p>{{district.district}}</p></td>
                                                <td class="font-weight-600"><p>{{district.election_problem_count}}</p></td>
                                            </tr>
                                        </template>
                                        <template v-if="regionProblemTypesModalInfo.secondList[0]?.election_userID !== null && modalMode.startsWith('seeDetailedStatistics')" v-for="(electionUser, i) of regionProblemTypesModalInfo.secondList">
                                            <tr class="light-black-color light-text">
                                                <td><p>{{`${electionUser.name} ${electionUser.surename}`}}</p></td>
                                                <td class="font-weight-600"><p>{{electionUser.election_date.slice(-8)}}</p></td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
  </primaryModalComponent>
  
</template>
<script>
import commonStatisticsBlock from '@/components/commonStatisticsBlock.vue';
import commonStatisticsBarChart from '@/components/commonStatisticsBarChart.vue';
import searchFilterBarComponent from "@/components/search-filterBarComponent.vue"
import commonCardAccordion from "@/components/commonCardAccordion.vue"
import Multiselect from '@vueform/multiselect'
import primaryButtonComponent from '@/components/primaryButtonComponent.vue';
import primaryModalComponent from '@/components/primaryModalComponent.vue';
import excelFileDownloadComponent from '@/components/excelFileDownloadComponent.vue';
import markerMapComponent from '@/components/markerMapComponent.vue';
import georgiaMap from '@/components/georgiaMap.vue';
import tbilisiMap from '@/components/tbilisiMap.vue';
import ascDescBlock from '@/components/ascDescBlock.vue';
import customProgressLine from '@/components/customProgressLine.vue'
import regions from "@/assets/regions.json"
import axios from 'axios';
export default {
    data(){
        return {
            // for main statistics >>   
            mainStatisticsInformation: {},
            maxActivityForElectionStatistic: 0,
            timeAllocationObj: {
                count9: "09:00",
                count10: "10:00",
                count11: "11:00",
                count12: "12:00",
                count13: "13:00",
                count14: "14:00",
                count15: "15:00",
                count16: "16:00",
                count17: "17:00",
                count18: "18:00",
                count19: "19:00",
                count20: "20:00",
            },
            detailedMainStatisticsOrderByButtonsArray: [
                {
                    content: "ამომრჩევლების რაოდენობა",
                    routeSetValue: "elect_count",
                    isActive: false,
                    activeMode: false,
                },
                {
                    content: "მხარდამჭერების რაოდენობა",
                    routeSetValue: "supporter_count",
                    isActive: false,
                    activeMode: false,
                }
            ],
            mainStatisticsPagingInfo: {
                offset: 1,
                limit: 11,
                total: 0,
            },
            // for detailed statistics all >>
            detailedElectionInfoAllgetterButtonsArray: [
                {
                    content: "ოლქი",
                    routeSetValue: "region",
                    mode: 0,
                },
                {
                    content: "უბანი",
                    routeSetValue: "district",
                    mode: 1,
                }
            ],
            detailedElectionInfoAllObj: {
                dataName: null,
                orderBy: null,
            },
            detailedElectionInformation: [],
            mainStatisticsjsonToExcelArray: [],
            mainStatisticsdownloadInAction: false,
            mainStatisticsAbortController: null,

            detailedPersonalActivityJsonToExcelArray: [],
            detailedPersonalActivityDownloadInAction: false,
            detailedPersonalActivityAbortController: null,
            choosenRegionID: null,

            detailedPersonalActivityByDistrictJsonToExcelArray: [],
            detailedPersonalActivityByDistrictDownloadInAction: false,
            detailedPersonalActivityByDistrictAbortController: null,
            choosenDistrictID: null,

            // for election problems >>

            isSending: false,
            accordionCardCloseTrigger: false,
            isAccordionOpened: false,
            indexOfOpenedAccordion: null,
            activatedFilterMode: 4,
            
            pagingInfo: {
                offset: 1,
                limit: 6,
                total: 0,
            },
            filteringPagingInfo: {
                offset: null,
                municipalityID: null,
                cityID:null,
                regionID: null,
                districtID:null,
                problemTypeID:null,
                hasComment:null,
                hasMedia: null,
                seen: null,
                mainStatisticsOffset: null,
                mainStatisticscityID:null,
                mainStatisticsregionID: null,
                mainStatisticsdistrictID:null,
                dataName: null,
                orderBy: null,
                problemTypesdataName: null,
                problemTypesorderBy: null,
                problemTypesOffset: null,
            },
            electionProblemsInfo: [],
            filtersInfoObj: {
                municipalityID: null,
                cityID:null,
                regionID: null,
                districtID:null,
                problemTypeID:null,
                checkBoxesArray: [],
                // hasComment:null,
                // hasMedia: null,
            },
            checkBoxesMultiselectArray: [
                {
                    placeholder: "დამატებითი ფილტრები",
                    options: [
                        {
                            sendName: "hasComment",
                            value: 1,
                            label: {
                                en: "has comment",
                                ge: "შეიცავდეს კომენტარს"
                            }
                        },
                        {
                            sendName: "hasMedia",
                            value: 2,
                            label: {
                                en: "has Media",
                                ge: "ფოტო/ვიდეო"
                            }
                        },
                        {
                            sendName: "seen",
                            value: 3,
                            label: {
                                en: "seen",
                                ge: "ნანახი"
                            }
                        },
                    ],
                    mode: "tags",
                    isDisabled: false,
                },
            ],
            mainStatisticsFiltersInfoObj: {
                cityID:null,
                regionID: null,
                districtID:null,
            },
            mainStatisticsMultiselectsArray: [
                {
                    
                },
                {
                    placeholder: "ოლქი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: false,
                },
                {
                    placeholder: "უბანი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
                {
                    placeholder: "უბნის ნომერი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
            ],
            localeMultiselectArray: [
                {
                    placeholder: "რეგიონი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: false,
                },
                {
                    placeholder: "ოლქი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: false,
                },
                {
                    placeholder: "უბანი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
                {
                    placeholder: "უბნის ნომერი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
            ],
            problemTypesMultiselectArray: [
                {
                    placeholder: "პრობლემის ტიპი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: false,
                },
            ],
            // for excel >>
            jsonToExcelArray: [],
            downloadInAction: false,
            electionProblemsAbortController: null,
            // << for excel 
            // for map >>
            pageMode: 0,
            currentlyHoveredRegion: {
                name: "",
                id: "",
            },
            currentlySelectedRegion: {
                name: "",
                id: "",
                element: null,
                details: "",
            },
            currentlySelectedTbilisiRegion: {
                name: "",
                id: "",
                element: null,
                details: "",
            },
            mapMode: 0,
            markerInfoArray: [],
            zoomedMarkerIndex: null,
            currentlySelectedRegionDetails: {},
            isTbilisiSelected: false,
            // << for map 

            // for modal >>
            modalTitle: "",
            modalSubTitle: "",
            showModal: false,
            audioURL: null,
            videoURL: "",
            photoURl: null,
            controller: null,
            modalMode: null,
            name: null,
            // bottom right module >>
            problemTypesFiltersInfoObj: {
                dataName: null,
                orderBy: null,
            },
            problemTypesButtonVmodel: {
                mode: null,
            },
            problemTypesFiltersMultiselectArray: [
                {
                    placeholder: "ოლქი/უბანი",
                    options: [
                        {
                            sendName: "region",
                            value: 0,
                            label: {
                                en: "region",
                                ge: "ოლქი"
                            }
                        },
                        {
                            sendName: "district",
                            value: 1,
                            label: {
                                en: "district",
                                ge: "უბანი"
                            }
                        },
                        
                    ],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: false,
                },  
            ],
            problemTypesOrderByButtonsObj:{
                content: "რაოდენობა",
                routeSetValue: "election_problem_count",
                isActive: true,
                activeMode: false,
            },
            problemTypesPagingInfo: {
                offset: 1,
                limit: 11,
                total: 0,
            },
            problemTypesInformation: [],
            regionProblemTypesModalInfo: {
                checkedElement: null,
                firstList: [],
                secondList: [],
            },
            menQuantityInDetailedActivity: 0,
            womenQuantityInDetailedActivity: 0,
            problemTypesjsonToExcelArray: [],
            problemTypesdownloadInAction: false,
            problemTypesAbortController: null,
        }
    },
    components: {
        commonStatisticsBlock,
        commonStatisticsBarChart,
        searchFilterBarComponent,
        commonCardAccordion,
        Multiselect,
        primaryButtonComponent,
        primaryModalComponent,
        excelFileDownloadComponent,
        markerMapComponent,
        georgiaMap,
        tbilisiMap,
        ascDescBlock,
        customProgressLine,
    },
    
    mounted(){
        this.removeAriaHidden();
        this.getElectionProblemTypes();
        this.routerMountMovement(this.$route);
        // setInterval(() => {
        //     console.log(this.mainStatisticsMultiselectsArray);
        //     console.log(this.mainStatisticsFiltersInfoObj);
        // }, 8000);
        // this.$watch(() => this.localeMultiselectArray[0].options, (newOptions, oldOptions) => {
        //         this.filtersInfoObj.municipalityID = this.filtersInfoObj.municipalityID;
        //         if(this.filtersInfoObj.municipalityID){
        //             this.allowNextMultiselect(this.filtersInfoObj.municipalityID, 1, false);
        //         }else{
        //             this.getCitiesAll();
        //         }
        //     },
        //     { deep: true }
        // );
        this.$watch(() => this.localeMultiselectArray[1].options, (newOptions, oldOptions) => {
                this.filtersInfoObj.cityID = this.filtersInfoObj.cityID;
                if(this.filtersInfoObj.cityID){
                    this.allowNextMultiselect(this.filtersInfoObj.cityID, 2, false, false, this.localeMultiselectArray, this.filtersInfoObj);
                }
            },
            { deep: true }
        );
        this.$watch(() => this.localeMultiselectArray[2].options, (newOptions, oldOptions) => {
                this.filtersInfoObj.regionID = this.filtersInfoObj.regionID;
                if(this.filtersInfoObj.regionID){
                    this.allowNextMultiselect(this.filtersInfoObj.regionID, 3, false, false, this.localeMultiselectArray, this.filtersInfoObj);
                }
            },
            { deep: true }
        );
        this.$watch(() => this.localeMultiselectArray[3].options, (newOptions, oldOptions) => {
                this.filtersInfoObj.regionID = this.filtersInfoObj.regionID;
            },
            { deep: true }
        );

        this.$watch(() => this.mainStatisticsMultiselectsArray[1].options, (newOptions, oldOptions) => {
                this.mainStatisticsFiltersInfoObj.cityID = this.mainStatisticsFiltersInfoObj.cityID;
                if(this.mainStatisticsFiltersInfoObj.cityID){
                    this.allowNextMultiselect(this.mainStatisticsFiltersInfoObj.cityID, 2, false, false, this.mainStatisticsMultiselectsArray, this.mainStatisticsFiltersInfoObj);
                    
                }
            },
            { deep: true }
        );
        this.$watch(() => this.mainStatisticsMultiselectsArray[2].options, (newOptions, oldOptions) => {
                this.mainStatisticsFiltersInfoObj.regionID = this.mainStatisticsFiltersInfoObj.regionID;
                if(this.mainStatisticsFiltersInfoObj.regionID){
                    this.allowNextMultiselect(this.mainStatisticsFiltersInfoObj.regionID, 3, false, false, this.mainStatisticsMultiselectsArray, this.mainStatisticsFiltersInfoObj);
                }
            },
            { deep: true }
        );
        this.$watch(() => this.mainStatisticsMultiselectsArray[3].options, (newOptions, oldOptions) => {
                this.mainStatisticsFiltersInfoObj.regionID = this.mainStatisticsFiltersInfoObj.regionID;
            },
            { deep: true }
        );

    },
    watch:{
        pageMode(newVal){
            if(newVal == 1){
                this.addListenersToPaths();
            }
        },
    },
    beforeRouteUpdate(to, from, next){
        let isQueriesValid = this.getInfoFromRoute(to);
        if(isQueriesValid){
            if(this.activatedFilterMode == 0){
                this.manageElectionUsersFilters(to);
            }else if(this.activatedFilterMode == 1){
                this.manageMainStatisticsFilters();
            }else if(this.activatedFilterMode == 2){
                this.manageDetailedElectionInfoAllFilters();
            }else if(this.activatedFilterMode == 3){
                this.manageProblemTypesFilters();
            }else if(this.activatedFilterMode == 4){
                this.manageElectionUsersFilters(to);
                this.manageMainStatisticsFilters();
                this.manageDetailedElectionInfoAllFilters();
                this.manageProblemTypesFilters();

            }
            next(true);
        }else{
            next(false);
            this.$helper.showSwal("არასწორი მისამართი", "error", "");
        }
        this.activatedFilterMode = 4;
    },
    methods: {
        manageReportTrColoring(event, i){
            if(this.regionProblemTypesModalInfo.checkedElement != null){
                this.regionProblemTypesModalInfo.checkedElement.classList.remove("active");
            }
            let clickedElement = document.getElementById('modal-left-report-body').children[i];
            clickedElement.classList.add("active");
            this.regionProblemTypesModalInfo.checkedElement = clickedElement;
        },
        getElectionProblemDistrictsByRegion(election_problem_typeID, regionID){
            this.$store.dispatch("getElectionProblemDistrictsByRegion", {election_problem_typeID, regionID}).then((response) => {
                this.regionProblemTypesModalInfo.secondList = response.data;
            })
        },
        getRegionsByCountryProblemType(election_problem_typeID, problemName){
            this.$store.dispatch("getRegionsByCountryProblemType", {election_problem_typeID}).then((response) => {
                this.regionProblemTypesModalInfo.firstList = response.data;
                this.modalTitle = `დეტალური ინფორმაცია: `;
                this.modalSubTitle = problemName;
            })
        },
        getElectionProblemTypesByDistrict(districtID, district){
            this.$store.dispatch("getElectionProblemTypesByDistrict", {districtID}).then((response) => {
                this.regionProblemTypesModalInfo.secondList = response.data;
                this.modalTitle = `დეტალური ინფორმაცია: `;
                this.modalSubTitle = district;
            })
        },
        getDistrictsByRegionAndProblemType(election_problem_typeID, regionID){
            this.$store.dispatch("getDistrictsByRegionAndProblemType", {election_problem_typeID, regionID}).then((response) => {
                this.regionProblemTypesModalInfo.secondList = response.data;
            })
        },
        getElectionProblemTypesByRegion(regionID, region){
            this.$store.dispatch("getElectionProblemTypesByRegion", regionID).then((response) => {
                this.modalTitle = `დეტალური ინფორმაცია: `;
                this.modalSubTitle = region;
                this.regionProblemTypesModalInfo.firstList= response.data;
            })
        },
        getDetailedStatisticProblem(){
            let problemTypesPaging = this.filteringPagingInfo.problemTypesOffset?Number(this.filteringPagingInfo.problemTypesOffset):0;
            this.$store.dispatch("getDetailedStatisticProblem", {...this.problemTypesFiltersInfoObj, offset: problemTypesPaging, limit: this.problemTypesPagingInfo.limit}).then((response) => {
                this.problemTypesInformation = response.data[0];
                
                this.problemTypesPagingInfo.total = response.data[1];
            })
        },
        manageProblemTypesFilters(){
            
            Object.keys(this.problemTypesFiltersInfoObj).forEach((key) => {
                if(key == "dataName"){
                    this.problemTypesFiltersInfoObj[key] = this.filteringPagingInfo[`problemTypes${key}`]?Number(this.filteringPagingInfo[`problemTypes${key}`]):2;
                }else{
                    this.problemTypesFiltersInfoObj[key] = this.filteringPagingInfo[`problemTypes${key}`]?this.filteringPagingInfo[`problemTypes${key}`]:"election_problem_count:desc";
                }
            })
            // set vmodels of multiselect button orderBy and paging
            this.problemTypesFiltersMultiselectArray[0].options.forEach((option, index) => {
                if(option.value == this.problemTypesFiltersInfoObj.dataName){
                    this.problemTypesFiltersMultiselectArray[0].Vmodel = option;
                    this.problemTypesButtonVmodel.mode = 2;
                }
            })
            if(this.problemTypesFiltersInfoObj.dataName == 2){
                this.problemTypesButtonVmodel.mode = 1;
                this.problemTypesFiltersMultiselectArray[0].Vmodel = null;
            }
            if(this.problemTypesFiltersInfoObj.orderBy.endsWith("asc")){
                this.problemTypesOrderByButtonsObj.activeMode = true;
            }else{
                this.problemTypesOrderByButtonsObj.activeMode = false;
            }
            

            
            this.problemTypesPagingInfo.offset = this.filteringPagingInfo.problemTypesOffset?(Number(this.filteringPagingInfo.problemTypesOffset) + 1):1;

            
            this.getDetailedStatisticProblem();
            
        },
        problemTypesOrderByButonHandler(){
            this.problemTypesOrderByButtonsObj.activeMode = !this.problemTypesOrderByButtonsObj.activeMode;
            let tempObj = {};
            // problemTypesOrderBy; problemTypesOffset
            if(this.problemTypesOrderByButtonsObj.activeMode){
                tempObj.problemTypesorderBy = "election_problem_count:asc";
            }else{
                tempObj.problemTypesorderBy = "election_problem_count:desc";
            }
            this.activatedFilterMode = 3;
            tempObj.problemTypesOffset = 0;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    ...tempObj,
                }
            });
        },
        handleProblemTypesRouteSet(specifier){
            let tempObj = {};
            // problemTypesdataName; problemTypesOrderBy; problemTypesOffset
            if(specifier == 1){
                tempObj.problemTypesdataName =  this.problemTypesFiltersMultiselectArray[0].Vmodel.value;
                this.problemTypesButtonVmodel.mode = 2;
            }else{
                this.problemTypesFiltersMultiselectArray[0].Vmodel = null;
                this.problemTypesButtonVmodel.mode = 1;
                tempObj.problemTypesdataName = 2;
            }
            this.activatedFilterMode = 3;
            tempObj.problemTypesorderBy = "election_problem_count:desc";
            tempObj.problemTypesOffset = 0;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    ...tempObj,
                }
            });
        },
        handleDetailedStatisticsAscDesc(orderByButtonIndex){
            let sortSetString = "";
            this.detailedMainStatisticsOrderByButtonsArray.forEach((orderByButton, index) => {
                if(orderByButtonIndex == index){
                    if(orderByButton.isActive){
                        orderByButton.activeMode = !orderByButton.activeMode;
                    }else{
                        orderByButton.isActive = true;
                        orderByButton.activeMode = false;
                    }
                    if(orderByButton.activeMode){
                        sortSetString = `${orderByButton.routeSetValue}:asc`;
                    }else{
                        sortSetString = `${orderByButton.routeSetValue}:desc`;
                    }
                }else{
                    orderByButton.isActive = false;
                    orderByButton.activeMode = false;
                }
            })
            this.activatedFilterMode = 2;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    orderBy: sortSetString,
                    mainStatisticsOffset: 0,
                }
            });
            
        },
        detailedElectionInfoAllGetterButtonsHandler(index){
            
            this.detailedElectionInfoAllgetterButtonsArray.forEach((getterButtonObj, getterButtonIndex) => {
                if(getterButtonIndex == index){   
                    getterButtonObj.mode = 0;
                    this.activatedFilterMode = 2;
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            ...this.$route.query,
                            dataName: getterButtonIndex, // 0, 1
                            orderBy: "elect_count:desc",
                            mainStatisticsOffset: 0,
                        },
                    });
                }else{
                    getterButtonObj.mode = 1;
                }
            })
        },
        mapGoBackHandler(){
            if(this.mapMode == 1){
                if(this.currentlySelectedTbilisiRegion.element){
                    this.currentlySelectedTbilisiRegion.element.classList.remove("activeRegion");
                }
                Object.keys(this.currentlySelectedRegion).forEach((key) => {
                    this.currentlySelectedRegion[key] = null;
                    // this.currentlyHoveredRegion[key] = null;
                    this.currentlySelectedTbilisiRegion[key] = null;
                })
                this.isTbilisiSelected = false;
                this.getCountryCount();
                this.addListenersToPaths();
                this.mapMode = 0;
            }else if(this.mapMode == 2){
                if(this.currentlySelectedTbilisiRegion.id){
                    this.currentlySelectedTbilisiRegion.name = null;
                    this.currentlySelectedTbilisiRegion.id = null;
                    this.currentlySelectedTbilisiRegion.element = null;
                    this.mapMode = 1;
                    this.currentlySelectedRegionDetails = {};
                    
                    // this.isTbilisiSelected = false;
                    this.fillMarkerInfoArray(-1);
                    this.setEventListenersToTbilisiPaths();
                }else{
                    Object.keys(this.currentlySelectedRegion).forEach((key) => {
                        this.currentlySelectedRegion[key] = null;
                        this.currentlyHoveredRegion[key] = null;
                        this.currentlySelectedTbilisiRegion[key] = null;
                    })
                    this.mapMode = 0;
                    this.currentlySelectedRegionDetails = {};
                    this.getCountryCount();
                    this.addListenersToPaths();
                }
                this.markerInfoArray = [];
                this.zoomedMarkerIndex = null;
            }
        },
        getDistrictDetails(id){
            this.$store.dispatch("getDistrictDetails", id).then((response) => {
                this.isTbilisiSelected = false;
                this.currentlySelectedRegionDetails = response.data;
                
            });
        },
        fillMarkerInfoArray(ID){
            
            this.$store.dispatch("getRegionsByPath", ID).then((response) => {
                if(response?.data?.districts?.length > 0){
                    let tempArray = [];
                    for(let district of response?.data?.districts){
                        if(district.lat != null){
                            tempArray.push({
                                latLng: {
                                    lat: Number(district.lat),
                                    lng: Number(district.lng),
                                    altitude: 0,
                                },
                                name: district.district,
                                address: district.address,
                                comment: district.district_name,
                                ID: district.districtID,
                            });
                        }
                    }
                    this.markerInfoArray = [];
                    this.markerInfoArray = tempArray;
                    setTimeout(() => {
                        this.zoomedMarkerIndex = 1;
                    },100);
                }
                if(ID == -1){
                    this.isTbilisiSelected = true;
                }else{
                    this.isTbilisiSelected = false;
                }
                this.currentlySelectedRegionDetails = response.data.details;
            }).catch((error) => {
            })
        },
        addListenersToPaths(){
            setTimeout(() => {
                Array.from(document.getElementById("map-svg").children).forEach((pathElement) => {
                    pathElement.addEventListener("click", (event) => {
                        if(event.target.getAttribute("id") != -99){
                            let regID = event.target.getAttribute("id");
                            let res = regions.find((element) => {
                                return element.id == regID;
                            })
                            if(regID == this.currentlySelectedRegion.id){
                                event.target.classList.remove("activeRegion");
                                this.currentlySelectedRegion.element = null;
                                this.currentlySelectedRegion.name = "";
                                this.currentlySelectedRegion.id = "";
                            }else if(res){
                                if(this.currentlySelectedRegion.element){
                                    this.currentlySelectedRegion.element.classList.remove("activeRegion");
                                }
                                // event.target.classList.add("activeRegion");
                                // this.currentlySelectedRegion.element = event.target;
                                this.currentlySelectedRegion.name = res.name;
                                this.currentlySelectedRegion.id = res.id;

                                this.currentlyHoveredRegion.name = "";
                                this.currentlyHoveredRegion.id = "";
                                if(regID == -1){
                                    this.mapMode = 1;
                                    this.fillMarkerInfoArray(-1);
                                    this.setEventListenersToTbilisiPaths();
                                }else{
                                    this.mapMode = 2;
                                    this.fillMarkerInfoArray(regID);
                                }

                            }
                        }
                    })
                    pathElement.addEventListener("mouseover", (event) => {
                        if(event.target.getAttribute("id") != -99){
                            let regID = event.target.getAttribute("id");
                            let res = regions.find((element) => {
                                return element.id == regID;
                            })
                            this.currentlyHoveredRegion.name = res.name;
                            this.currentlyHoveredRegion.id = res.id;
                        }
                    })
                    pathElement.addEventListener("mouseout", (event) => {
                        this.currentlyHoveredRegion.name = "";
                        this.currentlyHoveredRegion.id = "";
                    })
                })
            }, 100);
        },
        setEventListenersToTbilisiPaths(){
            setTimeout(() => {
                Array.from(document.getElementById("tbilisi-map-svg").children).forEach((tbilisiSubPath) => {
                    tbilisiSubPath.addEventListener("click", (event) => {
                        if(event.target.getAttribute("id") != -99){
                            let regID = event.target.getAttribute("id");
                            let res = regions.find((element) => {
                                return element.id == regID;
                            })
                            if(regID == this.currentlySelectedTbilisiRegion.id){
                                event.target.classList.remove("activeRegion");
                                this.currentlySelectedTbilisiRegion.element = null;
                                this.currentlySelectedTbilisiRegion.name = "";
                                this.currentlySelectedTbilisiRegion.id = "";
                            }else if(res){
                                if(this.currentlySelectedTbilisiRegion.element){
                                    this.currentlySelectedTbilisiRegion.element.classList.remove("activeRegion");
                                }
                                // event.target.classList.add("activeRegion");
                                // this.currentlySelectedTbilisiRegion.element = event.target;
                                this.currentlySelectedTbilisiRegion.name = res.name;
                                this.currentlySelectedTbilisiRegion.id = res.id;
    
                                this.mapMode = 2;
                                
                                
                                this.currentlyHoveredRegion.name = "";
                                this.currentlyHoveredRegion.id = "";
                                
                                this.fillMarkerInfoArray(regID);
                                this.isTbilisiSelected = false;
                            }
                        }
                    })
                    tbilisiSubPath.addEventListener("mouseover", (event) => {
                        if(event.target.getAttribute("id") != -99){
                            let regID = event.target.getAttribute("id");
                            let res = regions.find((element) => {
                                return element.id == regID;
                            })
                            if(res){
                                this.currentlyHoveredRegion.name = res.name;
                                this.currentlyHoveredRegion.id = res.id;
                            }else{
                                this.currentlyHoveredRegion.name = "";
                                this.currentlyHoveredRegion.id = "";
                            }
                            
                        }
                    })
                    tbilisiSubPath.addEventListener("mouseout", (event) => {
                        this.currentlyHoveredRegion.name = "";
                        this.currentlyHoveredRegion.id = "";
                    })
                })
            , 2000})
        },
        changePageMode(mode){
            if(mode == 0){
                this.mapMode = 0;
                if(this.currentlySelectedRegion.element){
                    this.currentlySelectedRegion.element.classList.remove("activeRegion");
                }
                if(this.currentlySelectedTbilisiRegion.element){
                    this.currentlySelectedTbilisiRegion.element.classList.remove("activeRegion");
                }
                Object.keys(this.currentlySelectedRegion).forEach((key) => {
                    this.currentlySelectedRegion[key] = null;
                    this.currentlyHoveredRegion[key] = null;
                    this.currentlySelectedTbilisiRegion[key] = null;
                })
                this.currentlySelectedRegionDetails = {};
                this.markerInfoArray = [];
                this.zoomedMarkerIndex = null;
            }else if(mode = 1){
                this.getCountryCount();
            }
            this.pageMode = mode;
        },
        getCountryCount(){
            this.$store.dispatch("getCountryCount").then((response) => {
                this.currentlySelectedRegionDetails = response.data;
            });
        },
        downloadImage(base64URL, name){
            const link = document.createElement('a');
            link.href = base64URL;
            link.download = name;
            link.click();
            URL.revokeObjectURL(link);
        },
        resetFilters(){
            Object.keys(this.filtersInfoObj).forEach((key) => {
                this.filtersInfoObj[key] = null;
            })
            this.blockNextMultiselects(2, this.localeMultiselectArray, this.filtersInfoObj);
            this.submitFilters();
        },
        submitFilters(){
            let tempObj = {};
            if(this.$route.query.offset){
                tempObj["offset"] = 0;
            }
            Object.keys(this.filtersInfoObj).forEach((key) => {
                if(Array.isArray(this.filtersInfoObj[key])){
                    this.filtersInfoObj[key].forEach((checkBoxObj) => {
                        tempObj[checkBoxObj.sendName] = true;
                    })
                }else{
                    if(this.filtersInfoObj[key]){
                        tempObj[key] = this.filtersInfoObj[key];
                    }
                }
            })
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if(this.filtersInfoObj.hasOwnProperty(queryKey) || queryKey == "hasComment" || queryKey == "hasMedia" || queryKey == "seen"){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })
            this.activatedFilterMode = 0;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        submitMianStatisticsFilters(){
            let tempObj = {};
            Object.keys(this.mainStatisticsFiltersInfoObj).forEach((key) => {
                if(this.mainStatisticsFiltersInfoObj[key]){
                    tempObj[`mainStatistics${key}`] = this.mainStatisticsFiltersInfoObj[key];
                }
            })
            this.activatedFilterMode = 1;
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if(this.mainStatisticsFiltersInfoObj.hasOwnProperty(`${queryKey.slice(14)}`) && queryKey.startsWith("mainStatistics")){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })
            
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        routerMountMovement(to){
            let isQueriesValid = this.getInfoFromRoute(to);
            if(isQueriesValid){
                this.manageElectionUsersFilters(to);
                this.getCitiesAll([this.localeMultiselectArray, this.mainStatisticsMultiselectsArray]);
                this.manageMainStatisticsFilters();
                this.manageDetailedElectionInfoAllFilters();
                this.manageProblemTypesFilters();
            }else{
                this.$router.replace(this.$route.path);
                this.$helper.showSwal("არასწორი მისამართი", "error", "");
            }
            this.activatedFilterMode = 4;
        },
        getInfoFromRoute(to){
            Object.keys(this.filteringPagingInfo).forEach((key) => {
                this.filteringPagingInfo[key] = null;
                if(key == "hasComment" || key == "hasMedia" || key == "seen"){
                    this.filteringPagingInfo[key] = to.query[key]?1:0;
                }else{
                    this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key].replace(/%/g, '%25')):null;
                }
            })
            
            let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
                if(this.filteringPagingInfo[key] == null){
                    return true;
                }else if(key == "orderBy"){
                    if(this.filteringPagingInfo[key] == "elect_count:desc" || this.filteringPagingInfo[key] == "elect_count:asc" 
                        || this.filteringPagingInfo[key] == "supporter_count:desc" || this.filteringPagingInfo[key] == "supporter_count:asc"){
                        return true;
                    }else {
                        return false;
                    }
                }else if(key == "problemTypesorderBy"){
                    if(this.filteringPagingInfo[key] == "election_problem_count:asc" || this.filteringPagingInfo[key] == "election_problem_count:desc"){
                        return true;
                    }else {
                        return false;
                    }
                }
                else{
                    return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
                }
            })
            return isQueriesValid;
        },
        manageDetailedElectionInfoAllFilters(){
            Object.keys(this.detailedElectionInfoAllObj).forEach((key) => {
                if(key == "dataName"){
                    
                    this.detailedElectionInfoAllObj[key] = Number(this.filteringPagingInfo[key]);
                }else{
                    this.detailedElectionInfoAllObj[key] = this.filteringPagingInfo[key]?this.filteringPagingInfo[key]:"elect_count:desc";
                }
            })
            
            this.detailedElectionInfoAllgetterButtonsArray.forEach((getterButtonObj, index) => {
                if(index == this.detailedElectionInfoAllObj.dataName){
                    
                    getterButtonObj.mode = 0;
                }else{
                    getterButtonObj.mode = 1;
                }
            })
            this.detailedMainStatisticsOrderByButtonsArray.forEach((orderByButton, index) => {
                if(this.detailedElectionInfoAllObj.orderBy.startsWith(orderByButton.routeSetValue)){
                    orderByButton.isActive = true;
                    if(this.detailedElectionInfoAllObj.orderBy.endsWith("asc")){
                        orderByButton.activeMode = true;
                    }else{
                        orderByButton.activeMode = false;
                    }
                }else{
                    orderByButton.isActive = false;
                    orderByButton.activeMode = false;
                }
            })

            let mainStatisticsPaging = this.filteringPagingInfo.mainStatisticsOffset?Number(this.filteringPagingInfo.mainStatisticsOffset):0;
            this.mainStatisticsPagingInfo.offset = this.filteringPagingInfo.mainStatisticsOffset?(Number(this.filteringPagingInfo.mainStatisticsOffset) + 1):1;
            
            this.$store.dispatch("getDetailedStatisticAll", {...this.detailedElectionInfoAllObj, offset: mainStatisticsPaging, limit: this.mainStatisticsPagingInfo.limit}).then((response) => {
                this.detailedElectionInformation = response.data[0];
                this.mainStatisticsPagingInfo.total = response.data[1];
            })
        },
        getDetailedStatisticsByRegion(modalSubTitle, regionID){
            this.modalTitle = "დეტალური აქტივობა:";
            this.modalSubTitle = modalSubTitle;
            this.choosenRegionID = regionID;
            this.$store.dispatch("getRegionActivities", {regionID}).then((response) => {
                this.regionProblemTypesModalInfo.firstList = response.data;
            })
        },
        getDetailedStatisticsByDistrict(modalSubTitle, districtID){
            this.modalTitle = "დეტალური აქტივობა:";
            this.modalSubTitle = modalSubTitle;
            this.choosenDistrictID = districtID;
            
            this.$store.dispatch("electionUsersByDistrict", {districtID}).then((response) => {
                this.menQuantityInDetailedActivity = 0;
                this.womenQuantityInDetailedActivity = 0;
                response.data.forEach((userObj) => {
                    
                    if(userObj.genderID == 0){
                        this.womenQuantityInDetailedActivity++;
                    }else{
                        this.menQuantityInDetailedActivity++;
                    }
                })
                this.regionProblemTypesModalInfo.secondList = response.data;
            });
        },
        
        manageMainStatisticsFilters(){
            Object.keys(this.mainStatisticsFiltersInfoObj).forEach((key) => {
                if(this.filteringPagingInfo[`mainStatistics${key}`]){
                    
                    this.mainStatisticsFiltersInfoObj[key] = Number(this.filteringPagingInfo[`mainStatistics${key}`]);
                }else{
                    this.mainStatisticsFiltersInfoObj[key] = this.filteringPagingInfo[`mainStatistics${key}`];
                }
            })
            if(!this.mainStatisticsFiltersInfoObj.cityID){
                this.blockNextMultiselects(2, this.mainStatisticsMultiselectsArray, this.mainStatisticsFiltersInfoObj);
            }else if(!this.mainStatisticsFiltersInfoObj.regionID){
                this.blockNextMultiselects(3, this.mainStatisticsMultiselectsArray, this.mainStatisticsFiltersInfoObj);
            }

            if(this.mainStatisticsFiltersInfoObj.cityID){
                this.allowNextMultiselect(this.mainStatisticsFiltersInfoObj.cityID, 2, false, false, this.mainStatisticsMultiselectsArray, this.mainStatisticsFiltersInfoObj);
            }else if(this.mainStatisticsFiltersInfoObj.regionID){
                this.allowNextMultiselect(this.mainStatisticsFiltersInfoObj.cityID, 3, false, false, this.mainStatisticsMultiselectsArray, this.mainStatisticsFiltersInfoObj);
            }
            this.$store.dispatch("electionStatistic", this.mainStatisticsFiltersInfoObj).then((response) => {
                this.mainStatisticsInformation = response.data;
                let result = Object.keys(this.mainStatisticsInformation.timeAllocation).reduce((accumulator, element) => {
                    let prevValue = this.mainStatisticsInformation.timeAllocation[accumulator];
                    let nextValue = this.mainStatisticsInformation.timeAllocation[element];
                    
                    
                    if(/(count)[0-9]{1}/.test(accumulator) && /(count)[0-9]{1}/.test(element)){
                        if(Number(prevValue) < Number(nextValue)){
                            return element
                        }else{
                            return accumulator;
                        }
                    }else{
                        return element;
                    }
                    
                })
                this.maxActivityForElectionStatistic = this.mainStatisticsInformation.timeAllocation[result];
            });
        },
        manageElectionUsersFilters(to){
            Object.keys(this.filtersInfoObj).forEach((key) => {
                if(Array.isArray(this.filtersInfoObj[key])){
                    this.filtersInfoObj[key] = [];
                
                    if(this.filteringPagingInfo.hasComment){
                        this.filtersInfoObj[key].push({
                            ...this.checkBoxesMultiselectArray[0].options[0],
                        });
                    }
                    if(this.filteringPagingInfo.hasMedia){
                        this.filtersInfoObj[key].push({
                            ...this.checkBoxesMultiselectArray[0].options[1]
                        });
                    }
                    if(this.filteringPagingInfo.seen){
                        this.filtersInfoObj[key].push({
                            ...this.checkBoxesMultiselectArray[0].options[2]
                        });
                    }
                }else{
                    if(this.filteringPagingInfo[key]){
                        this.filtersInfoObj[key] = Number(this.filteringPagingInfo[key]);
                    }else{
                        this.filtersInfoObj[key] = this.filteringPagingInfo[key];
                    }
                }
            })
            if(!this.filtersInfoObj.cityID){
                this.blockNextMultiselects(2, this.localeMultiselectArray, this.filtersInfoObj);
            }else if(!this.filtersInfoObj.regionID){
                this.blockNextMultiselects(3, this.localeMultiselectArray, this.filtersInfoObj);
            }

            if(this.filtersInfoObj.cityID){
                this.allowNextMultiselect(this.filtersInfoObj.cityID, 2, false, false, this.localeMultiselectArray, this.filtersInfoObj);
            }else if(this.filtersInfoObj.regionID){
                this.allowNextMultiselect(this.filtersInfoObj.cityID, 3, false, false, this.localeMultiselectArray, this.filtersInfoObj);
            }
            // this.getMunicipalities();
            // this.getCitiesAll();
            this.pagingInfo.offset = to.query.offset?(Number(to.query.offset) + 1):1;
            this.getElectionUserProblems();
        },
        activateModalMode(modalMode, isOpen){
            if(modalMode == "video"){
                this.modalTitle = "ვიდეო მასალა";
            }else if(modalMode == "photo"){
                this.modalTitle = "ფოტო მასალა";
            }else if(modalMode.startsWith("seeProblemTypesReport")){
                // this.modalTitle = "დეტალური ჩამონათვალი";
            }else if(modalMode == "audio"){
                this.modalTitle = "აუდიო მასალა";
            }
            this.modalMode = modalMode;
            this.triggerModal(isOpen);
        },
        triggerModal(value){
            if(value == false){
                this?.controller?.abort();
                this.modalTitle = "";
                URL.revokeObjectURL(this.videoURL);
                URL.revokeObjectURL(this.audioURL);
                this.videoURL = null;
                this.photoURl = null;
                this.name = null;
                this.audioURL = null;
                this.regionProblemTypesModalInfo.firstList = [];
                this.regionProblemTypesModalInfo.secondList = [];
                this.choosenDistrictID = null;
                this.choosenRegionID = null;
                this.modalSubTitle = "";
            }
            this.showModal = value;
        },
        setElectionPhoto(photoURL, name){
            this.photoURl = photoURL;
            this.name = name;
        },
        getElectionProblemAudio(obj){
            this.isSending = true;
            this.controller = new AbortController();
            this.audioURL = null;
            axios.post("getElectionProblemAudio", obj, {
                responseType: 'blob',
                signal: this.controller.signal,
            }).then((response) => {
                const audioBlob = new Blob([response.data], {
                    type: "audio/mpeg",
                });
                this.audioURL = URL.createObjectURL(audioBlob);
                let audioElement = document.getElementById("mainAudio");
                audioElement.src = this.audioURL;
            }).catch((error) => {
                if (error.code === 'ERR_CANCELED') {
                } else {
                }
            }).finally((response) => {
                this.isSending = false;
            })
        },
        getElectionProblemVideo(obj){
            this.isSending = true;
            this.controller = new AbortController();
            this.videoURL = null;

            axios.post("getElectionProblemVideo", obj, {
                responseType: 'blob',
                signal: this.controller.signal,
            }).then((response) => {
                const videoBlob = new Blob([response.data],{ type: 'video/mp4' });
                
                this.videoURL = URL.createObjectURL(videoBlob);
                let videoElement = document.getElementById("mainVideo");
                
                videoElement.src = this.videoURL;
                // videoElement.onloadeddata = () => {
                //     URL.revokeObjectURL(this.videoURL);
                // }
            }).catch((error) => {
                if (error.code === 'ERR_CANCELED') {
                } else {
                }
            }).finally((response) => {
                this.isSending = false;
            })
        },
        getElectionProblemTypes(){
            this.$store.dispatch("getElectionProblemTypes").then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.election_problem_typeID,
                        label: {
                            ge: obj.election_problem_type,
                            en: obj.election_problem_typeeng,
                        },
                    });
                }
                this.problemTypesMultiselectArray[0].options = tempArray;
            });
        },
        allowNextMultiselect(value, index, clear, blockNext, changingArray, filterVModelsArray){
            if(value){
                if(index == 1){
                    this.getCities(value, clear, changingArray, filterVModelsArray);
                }else if(index == 2){
                    this.getRegions(value, clear, changingArray, filterVModelsArray);
                }else if(index == 3){
                    this.getDistricts(value, clear, changingArray, filterVModelsArray);
                }
            }
            
            if(index < changingArray.length - 1 && blockNext){
                this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
            }
        },
        blockNextMultiselects(index, changingArray, filterVModelsArray){
            
            if(index >= changingArray.length){
                return;
            }
            
            changingArray[index].options = [];
            if(index == 1){
                filterVModelsArray.cityID = null;
                this.getCitiesAll([this.localeMultiselectArray]);
            }else if(index == 2){
                filterVModelsArray.regionID = null;
            changingArray[index].isDisabled = true;
            }else if(index == 3){
                filterVModelsArray.districtID = null;
                changingArray[index].isDisabled = true;
            }
            this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
        },
        removeAriaHidden(){
            Array.from(document.querySelectorAll('.multiselect span[aria-hidden]')).forEach((item) => {
                item.removeAttribute('aria-hidden');
            })
            Array.from(document.querySelectorAll('.multiselect .multiselect-search[aria-labelledby]')).forEach((item) => {
                item.removeAttribute('aria-labelledby');
            })
        },
        getDistricts(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getDistricts",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.districtID,
                        label: {
                            ge: obj.district,
                            en: obj.district,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.districtID = null;
                }
                changingArray[3].options = tempArray;
                changingArray[3].isDisabled = false;
            })
        },
        getRegions(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getRegions",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.regionID,
                        label: {
                            ge: `${obj.region} ${obj.pathID?`- ${obj.pathID}`:""}`,
                            en: `${obj.regioneng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.regionID = null;
                }
                changingArray[2].options = tempArray;
                changingArray[2].isDisabled = false;
            })
        },
        getCitiesAll(changingArray){
            this.$store.dispatch("getCitiesAll").then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.cityID,
                        label: {
                            ge: `${obj.city} ${obj.pathID?`- ${obj.pathID}`:""}`,
                            en: `${obj.cityeng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        },
                    });
                }
                changingArray.forEach((destArray) => {
                    destArray[1].options = tempArray;
                    destArray[1].isDisabled = false;
                })
                // changingArray[1].options = tempArray;
                // changingArray[1].isDisabled = false;
            })
        },
        getCities(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getCities",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.cityID,
                        label: {
                            ge: obj.city,
                            en: obj.cityeng,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.cityID = null;
                }
                changingArray[1].options = tempArray;
                changingArray[1].isDisabled = false;
            })
        },
        getMunicipalities(){
            this.$store.dispatch("getMunicipalities").then((response) => {
                
                let tempArray = [];
                for(let municipality of response.data){
                    tempArray.push({
                        value: municipality.municipalityID,
                        label: {
                            ge: municipality.municipality,
                            en: municipality.municipalityeng,
                        },
                    });
                }
                
                this.localeMultiselectArray[0].options = tempArray;
            })
        },
        problemTypesAbortDownload(){
            this?.problemTypesAbortController?.abort();
            this.problemTypesAbortController = null;
        },
        async problemTypesIgniteDownload(){
            let firstArray = [];
            let secondArray = [];
            let thirdArray = [];
            this.problemTypesjsonToExcelArray = [];
            this.problemTypesAbortController = new AbortController();
            this.isSending = true;

            await Promise.all([
                this.$store.dispatch("getDetailedStatisticProblem", {...this.problemTypesFiltersInfoObj, dataName: 2 ,limit: Number.MAX_SAFE_INTEGER, offset: 0, signal: this.problemTypesAbortController.signal}),
                this.$store.dispatch("getDetailedStatisticProblem", {...this.problemTypesFiltersInfoObj, dataName: 0 ,limit: Number.MAX_SAFE_INTEGER, offset: 0, signal: this.problemTypesAbortController.signal}),
                this.$store.dispatch("getDetailedStatisticProblem", {...this.problemTypesFiltersInfoObj, dataName: 1 ,limit: Number.MAX_SAFE_INTEGER, offset: 0, signal: this.problemTypesAbortController.signal}),
            ]).then((response) => {
                firstArray.push([
                    "პრობლემის ტიპი",
                    "პრობლემის რაოდენობა",
                ]);
                response[0].data[0].forEach((obj) => {
                    firstArray.push([
                        obj.election_problem_type,
                        obj.election_problem_count?obj.election_problem_count:0,
                    ]);
                })

                secondArray.push([
                    "ოლქი",
                    "პრობლემების რაოდენობა",
                ]);
                response[1].data[0].forEach((obj) => {
                    secondArray.push([
                        obj.region,
                        obj.election_problem_count?obj.election_problem_count:0,
                    ]);
                })

                thirdArray.push([
                    "უბანი",
                    "პრობლემების რაოდენობა",
                ]);
                response[2].data[0].forEach((obj) => {
                    thirdArray.push([
                        obj.district,
                        obj.election_problem_count?obj.election_problem_count:0,
                    ]);
                })

                this.problemTypesjsonToExcelArray.push(firstArray);
                this.problemTypesjsonToExcelArray.push(secondArray);
                this.problemTypesjsonToExcelArray.push(thirdArray);
                this.problemTypesdownloadInAction = !this.problemTypesdownloadInAction;
                this.problemTypesAbortController = null;
                this.isSending = false;
            }).catch(() => {

            }).finally(() => {
                this.problemTypesAbortController = null;
                this.isSending = false;
            })

            
            
        },
        detailedPersonalActivityByDistrictAbortDownload(){
            this?.detailedPersonalActivityByDistrictAbortController?.abort();
            this.detailedPersonalActivityByDistrictAbortController = null;
        },
        detailedPersonalActivityByDistrictDownloadIgnition(){
            let firstArray = [];
            this.detailedPersonalActivityByDistrictJsonToExcelArray = [];
            this.isSending = true;
            this.detailedPersonalActivityByDistrictAbortController = new AbortController();
            this.$store.dispatch("electionUsersByDistrict", {districtID: this.choosenDistrictID, signal: this.detailedPersonalActivityByDistrictAbortController.signal}).then((response) => {
                firstArray.push([
                    "სახელი",
                    "გვარი",
                    "ხმის მიცემის დრო",
                    "სულ აქტივობა",
                ]);
                response.data.forEach((obj) => {
                    firstArray.push([
                        obj.name,
                        obj.surename,
                        obj.election_date,
                        response.data.length,
                    ]);
                })
                this.detailedPersonalActivityByDistrictJsonToExcelArray.push(firstArray);
                this.detailedPersonalActivityByDistrictDownloadInAction = !this.detailedPersonalActivityByDistrictDownloadInAction;
                this.detailedPersonalActivityByDistrictAbortController = null;
                this.isSending = false;
            }).catch(() => {});
        },
        detailedPersonalActivityAbortDownload(){
            this?.detailedPersonalActivityAbortController?.abort();
            this.detailedPersonalActivityAbortController = null;
        },
        async detailedPersonalActivityDownloadIgnition(){
            let firstArray = [];
            this.detailedPersonalActivityJsonToExcelArray = [];
            this.isSending = true;
            this.detailedPersonalActivityAbortController = new AbortController();
            await this.$store.dispatch("electionUsersByDistrictForExcel", {regionID: this.choosenRegionID, signal: this.detailedPersonalActivityAbortController.signal}).then((response) => {
                firstArray.push([
                    "სახელი",
                    "გვარი",
                    "უბანი",
                    "ხმის მიცემის დრო",
                    "სულ აქტივობა",
                ]);
                response.data.forEach((obj) => {
                    firstArray.push([
                        obj.name,
                        obj.surename,
                        obj.districts.district,
                        obj.election_date,
                        response.data.length,
                    ]);
                })
                this.detailedPersonalActivityJsonToExcelArray.push(firstArray);
                this.detailedPersonalActivityDownloadInAction = !this.detailedPersonalActivityDownloadInAction;
                this.detailedPersonalActivityAbortController = null;
                this.isSending = false;
            }).catch(() => {});
        },
        abortDetailedStatisticsDownload(){
            this?.mainStatisticsAbortController?.abort();
            this.mainStatisticsAbortController = null;
        },
        async igniteDetailedStatisticsDownload(){
            let firstArray = [];
            let secondArray = [];
            this.mainStatisticsjsonToExcelArray = [];
            this.mainStatisticsAbortController = new AbortController();
            
            this.isSending = true;

            
            await Promise.all([
                this.$store.dispatch("getDetailedStatisticAll", {...this.detailedElectionInfoAllObj, dataName: 1 ,limit: Number.MAX_SAFE_INTEGER, offset: 0, signal: this.mainStatisticsAbortController.signal}).catch(() => {}),
                this.$store.dispatch("getDetailedStatisticAll", {...this.detailedElectionInfoAllObj, dataName: 0,limit: Number.MAX_SAFE_INTEGER, offset: 0, signal: this.mainStatisticsAbortController.signal}).catch(() => {}),
            ]).then((response) => {
                firstArray.push([
                    "უბანი",
                    "ოლქი",
                    "ამომრჩევლების აქტიურობა",
                    "მხარდამჭერების აქტიურობა",
                    "პრობლემების რაოდენობა",
                ]);
                response[0].data[0].forEach((obj) => {
                    firstArray.push([
                        obj.district,
                        obj.region,
                        `${obj.elect_count}/${obj.sum_count?obj.sum_count:0} - ${obj.sum_count?(Number(obj.elect_count)/Number(obj.sum_count)*100).toFixed(2):0}%`,
                        `${obj.supporter_count}/${obj.district_supporter_count?obj.district_supporter_count:0} - ${obj.district_supporter_count?(Number(obj.supporter_count)/Number(obj.district_supporter_count)*100).toFixed():0}%`,
                        obj.problem_count,
                    ]);
                });

                secondArray.push([
                    "ოლქი",
                    "ამომრჩევლების აქტიურობა",
                    "მხარდამჭერების აქტიურობა",
                    "პრობლემების რაოდენობა",
                ]);
                response[1].data[0].forEach((obj) => {
                    secondArray.push([
                        obj.region,
                        `${obj.elect_count}/${obj.sum_count?obj.sum_count:0} - ${obj.sum_count?(Number(obj.elect_count)/Number(obj.sum_count)*100).toFixed(2):0}%`,
                        `${obj.supporter_count}/${obj.region_supporter_count?obj.region_supporter_count:0} - ${obj.region_supporter_count?(Number(obj.supporter_count)/Number(obj.region_supporter_count)*100).toFixed():0}%`,
                        obj.problem_count,
                    ]);
                })
                this.mainStatisticsjsonToExcelArray.push(firstArray);
                this.mainStatisticsjsonToExcelArray.push(secondArray);
                this.mainStatisticsdownloadInAction = !this.mainStatisticsdownloadInAction;
                this.mainStatisticsAbortController = null;
                this.isSending = false;
            }).catch((error) => {

            }).finally(() => {
                this.mainStatisticsAbortController = null;
                this.isSending = false;
            });
            
        },
        electionProblemsAbortDownload(){
            this?.electionProblemsAbortController?.abort();
            this.electionProblemsAbortController = null;
        },
        async igniteDownload(){
            let firstArray = [];
            this.jsonToExcelArray = [];
            this.electionProblemsAbortController = new AbortController();
            this.isSending = true;
            
            await this.$store.dispatch("getElectionUserProblems", {...this.filteringPagingInfo ,limit: Number.MAX_SAFE_INTEGER, offset: 0, signal: this.electionProblemsAbortController.signal}).then((response) => {
                firstArray.push([
                    "სახელი",
                    "გვარი",
                    "უბანი",
                    "უბნის მისამართი",
                    "პრობლემა",
                    "კომენტარები",
                    "თარიღი",
                ]);
                response.data[0].forEach((obj) => {
                    firstArray.push([
                        obj.user.name,
                        obj.user.surename,
                        `${obj.district.district} - ${obj.district.district_name}`,
                        obj.district.address,
                        obj.problem_type.election_problem_type,
                        obj.comment,
                        obj.election_date,
                    ]);
                })
                this.jsonToExcelArray.push(firstArray);
    
                this.downloadInAction = !this.downloadInAction;
                this.electionProblemsAbortController = null;
                this.isSending = false;
            }).catch(() => {

            }).finally(() => {
                this.electionProblemsAbortController = null;
                this.isSending = false;
            });
        },
        openAccordionOnIndex(index, election_problemID, seen){
            if(seen != 1){
                this.electionProblemsInfo[index].seen = 1;
                this.$store.dispatch("electionProblemIsSeen", election_problemID).then((response) => {
                }).catch((error) => {
                })
            }
            this.indexOfOpenedAccordion = index;
            this.isAccordionOpened = true;
        },
        closeAccordionOnIndex(index){
            this.indexOfOpenedAccordion = null;
            this.isAccordionOpened = false;
        },
        problemTypesPaginationClickHandler(value){
            this.activatedFilterMode = 3;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    problemTypesOffset: encodeURIComponent(value - 1),
                }
            });
            
        },
        mainStatisticsPaginationClickHandler(value){
            this.activatedFilterMode = 2;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    mainStatisticsOffset: encodeURIComponent(value - 1),
                }
            });
        },
        paginationClickHandler(value){
            this.activatedFilterMode = 0;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    offset: encodeURIComponent(value - 1),
                }
            });
        },
        getElectionUserProblems(){
            this.$store.dispatch("getElectionUserProblems", {...this.filteringPagingInfo, limit: this.pagingInfo.limit}).then((response) => {
                this.electionProblemsInfo = response.data[0];
                this.pagingInfo.total = response.data[1];
                this.accordionCardCloseTrigger = !this.accordionCardCloseTrigger;
                this.isAccordionOpened = false;
                this.indexOfOpenedAccordion = null;
            })
        },
    }
}
</script>
<style scoped>
.home-container{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, min-content);
    row-gap: 1.5em;
    overflow: hidden;
}
.election-common-statistics-grid-wrapper{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    gap: 0.7em;
}
.election-common-statistics-grid-wrapper .election-main-statistics-wrapper{
    background-color: var(--secondary-background-color);
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    padding: 32px;
    border-radius: 0.7em;
}
.election-common-statistics-grid-wrapper .live-amount{
    font-size: 48px;
    font-family: "firaGo-700", Helvetica, Arial, sans-serif;
}
.data-according-to-time{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, auto);
    grid-auto-flow: column;
    gap: 2em;
}
.election-common-statistics-grid-wrapper .statistics-info{
    font-size: 24px;
    font-family: "firaGo-700", Helvetica, Arial, sans-serif;
}
.detailed-statistics{
    background-color: var(--secondary-background-color);
    padding: 32px;
    border-radius: 0.7em;
}
.common-table-container :is(td, th), .election-cards-and-table-wrapper .common-table-container :is(td, th){
    padding: 5px 5px;
}
.common-table-container th, .election-cards-and-table-wrapper .common-table-container th{
    white-space: wrap;
    text-overflow: ellipsis;
}
.common-table-container tr :is(th:nth-child(1), td:nth-child(1)) , .election-cards-and-table-wrapper .common-table-container tr :is(th:nth-child(1), td:nth-child(1)){
    text-align: start;
}



/* for main-info-wrapper >>> */
.election-map-wrapper{
    height: 400px;
    background-color: var(--secondary-background-color);
    border-radius: 0.7em;
}
.main-info-section{
  overflow: hidden;
}
.cards-common-grid-wrapper{
    grid-template-rows: repeat(5, minmax(0, max-content));
}

.election-cards-and-table-wrapper{
    display: grid;
    grid-template-columns: 65% auto;
    grid-template-rows: min-content;
    gap: 0.7em;
}
/* for filters >>  */
.search-container{
    justify-content: space-between;
    align-items: center;
    background-color: var(--secondary-background-color);
    border-radius: 10px;
    padding: 15px;
    column-gap: 3em;
}
.search-container-form{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1em;
}
.search-container-form .filters-wrapper{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: center;
    gap: 15px;
}
input[type="checkbox"]{
    width: 20px;
    height: 20px;
}
.search-container-form .filters-wrapper .multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    max-width: 235px;
    margin: 0;
}
/* << for filters */





.election-cards-and-table-wrapper .election-left-side{
    background-color: var(--secondary-background-color);
    grid-column: 1 / 2;
    grid-row: 1 / 2;
}
.exit-poll-wrapper{
    background-color: var(--secondary-background-color);
}
.election-cards-and-table-wrapper .table-wrapper{
    background-color: var(--secondary-background-color);
    height: 800px;
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    /* padding: 2em 2em 3em 2em; */
    overflow: hidden;
}
.common-table-container{
    padding: 0;
}
.blue-part-input:not(textarea){
    padding: 0.7em 2em;
    border-radius: 20px;
}
textarea.blue-part-input{
    resize: none;
    height: 100px;
    padding: 8px;
}
.problem-images-wrapper img{
    height: 92px;
    aspect-ratio: 1 / 1;
    object-fit: contain;
}
.image-wrapper{
    position: relative;
    width: min-content;
}
.image-wrapper .download-button{
    position: absolute;
    padding: 5px;
    background-color: #ffffffd1;
    border-radius: 7px;
    right: 3px;
    top: 3px;
}
/* .modal-photo{
    width: 100%;
} */
.modal-media{
    max-height: 550px;
}
.modal-reports-wrapper{
    max-height: 550px;
}
.modal-reports-wrapper #modal-left-report-body tr:hover{
    background-color: rgba(113, 142, 191, 0.705);
}
.modal-reports-wrapper #modal-left-report-body tr.active{
    background-color: rgba(113, 142, 191, 0.705);
}
/* map section >> */
.map-section-wrapper{
    display: grid;
    grid-template-columns: 65% 34%;
    grid-template-rows: 1fr;
    gap: 1%;
}
.map-section-wrapper .map-wrapper{
    position: relative;
    grid-column: 1 / 2;
    padding: 2em 2em 5em 2em;
}
.map-section-wrapper .map-side-bar{
    grid-column: 2 / 3;
}
.map-section-wrapper .map-side-bar,.map-section-wrapper .map-wrapper{
    background-color: var(--secondary-background-color);
    border-radius: 20px;
}
.map-side-bar-header{
    border-bottom: 1px solid gray;
}
.map-side-bar-common-block{
    display: grid;
    grid-template-columns: 40% 40% 20%;
    grid-template-rows: 1fr;
    width: 100%;
    padding: 0.7em;
    background-color: inherit;
    border-radius: 10px;
    border: 3px solid;
}
.common-right-border{
    border-right: 3px solid transparent;
    padding: 0.5em;
}
.green-border{
    border-color: rgba(31, 210, 136, 0.5);
}
.blue-border{
    border-color: rgba(30, 94, 255, 0.5);
}
.orange-border{
    border-color: rgba(255, 203, 16, 0.5);
}

.map-hover-info-button{
    z-index: 50;
    padding: 1em;
    position: absolute;
    left: 1em;
    bottom: 1em;
    background-color: var(--middle-gray);
    min-width: 200px;
    border-radius: 10px;
}
.go-back-button{
    z-index: 50;
    position: absolute;
    bottom: 1em;
    right: 1em;
}

@media screen and (max-width: 2100px) {
    .election-common-statistics-grid-wrapper .extra-large-text{
        font-size: 20px;
        line-height: 28px;
    }
    .election-common-statistics-grid-wrapper .live-amount{
        font-size: 36px;
    }
    .election-common-statistics-grid-wrapper .statistics-info{
        font-size: 22px;
        font-family: "firaGo-700", Helvetica, Arial, sans-serif;
    }
    .after-extra-large-text{
        font-size: 22px;
        line-height: 30px;
    }
}

@media screen and (max-width: 1900px) {
    .election-common-statistics-grid-wrapper {
        grid-template-columns: repeat(2, 1fr);
    }
    .election-common-statistics-grid-wrapper .extra-large-text{
        font-size: 18px;
        line-height: 24px;
    }
    .election-common-statistics-grid-wrapper .live-amount{
        font-size: 30px;
    }
    .election-common-statistics-grid-wrapper .statistics-info{
        font-size: 20px;
        font-family: "firaGo-700", Helvetica, Arial, sans-serif;
    }
    .after-extra-large-text{
        font-size: 20px;
        line-height: 26px;
    }
}

@media screen and (max-width: 1800px) {
    .search-container{
        justify-content: space-between;
        align-items: flex-start;
    }
    .search-container.mode-1 .primary-input{
        max-width: 400px;
    }
    .search-container-form{
        flex-direction: column;
        align-items: flex-start;
    }
    .search-container-form > h6, .excel-export-button{
        margin: 0;
    }
    .search-container-form .filters-wrapper .multiselect{
        max-width: 170px;
    }
    .election-common-statistics-grid-wrapper .extra-large-text{
        font-size: 15px;
        line-height: 20px;
    }
    .election-common-statistics-grid-wrapper .live-amount{
        font-size: 24px;
    }
    .election-common-statistics-grid-wrapper .statistics-info{
        font-size: 20px;
        font-family: "firaGo-700", Helvetica, Arial, sans-serif;
    }
    .after-extra-large-text{
        font-size: 16px;
        line-height: 20px;
    }
}
@media screen and (max-width: 1750px) {
    .election-common-statistics-grid-wrapper .election-main-statistics-wrapper{
        padding: 20px;
    }
    .detailed-statistics{
        padding: 20px;
    }
    .statistics-block{
        padding: 16px;
    }
    .data-according-to-time{
        gap: 1em;
    }
}
@media screen and (max-width: 1720px) {
    .election-common-statistics-grid-wrapper{
        grid-template-columns: repeat(2, 1fr);
    }
    .modal-reports-wrapper{
        max-height: 480px;
    }
    .modal-media{
        max-height: 450px;
    }
}
@media screen and (max-width: 1560px) {
    .election-common-statistics-grid-wrapper .election-main-statistics-wrapper{
        padding: 15px;
    }
    .detailed-statistics{
        padding: 15px;
    }
    .statistics-block{
        padding: 12px;
    }
    .data-according-to-time{
        gap: 0.7em;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(4, auto);
    }
    .election-common-statistics-grid-wrapper .extra-large-text{
        font-size: 15px;
        line-height: 18px;
    }
    .election-common-statistics-grid-wrapper .live-amount{
        font-size: 20px;
    }
    .election-common-statistics-grid-wrapper .statistics-info{
        font-size: 16px;
        font-family: "firaGo-700", Helvetica, Arial, sans-serif;
    }
    .after-extra-large-text{
        font-size: 14px;
        line-height: 18px;
    }
    .election-cards-and-table-wrapper .table-wrapper{
        max-height: 650px;
    }
    .modal-reports-wrapper{
        max-height: 400px;
    }
    .modal-media{
        max-height: 450px;
    }
}
@media screen and (max-width: 1310px) {
    .search-container-form .filters-wrapper .multiselect{
        min-width: 120px;
    }
}
@media screen and (max-width: 1140px) {
    .election-common-statistics-grid-wrapper{
        grid-template-columns: repeat(2, 1fr);
    }
    .election-common-statistics-grid-wrapper .election-main-statistics-wrapper{
        grid-column: 1 / 2;
    }
}
@media screen and (max-width: 992px) {
    .election-common-statistics-grid-wrapper .statistics-info{
        font-size: 18px;
        font-family: "firaGo-700", Helvetica, Arial, sans-serif;
    }
}
</style>